(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[7],{

/***/ "/Mt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useResponsive; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Responsive_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("GRjW");
/* harmony import */ var _getCurrentResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ZCNJ");



var ResponsiveContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(Object(_getCurrentResponsive__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
  currentBreakpoint: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_1__[/* getCurrentBreakpoint */ "a"])('', false),
  isAppMounted: false
}));
/* harmony default export */ __webpack_exports__["a"] = (ResponsiveContext);
var useResponsive = function useResponsive() {
  var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(ResponsiveContext);

  if (context === undefined) {
    throw new Error('useResponsive must be used within a Responsive.Provider');
  }

  return context;
};

/***/ }),

/***/ "0Hfl":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ "0zX2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "1RIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export localStorageAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setInLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return remove; });
/* unused harmony export clearLocalStorage */
/* harmony import */ var _components_utils_feature_testing_FeatureTesting__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("L9Lm");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);


function localStorageAvailable() {
  return _components_utils_feature_testing_FeatureTesting__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].getTestResult('localstorage');
}

function safeJSONParse(o) {
  try {
    return JSON.parse(o);
  } catch (e) {
    return null;
  }
}

function setInLocalStorage(key, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      ttl = _ref.ttl,
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? Date.now() : _ref$date;

  if (localStorageAvailable()) {
    localStorage.setItem(key, JSON.stringify({
      value: value,
      expireTs: ttl ? date + ttl : null
    }));
  }
} // Date.now is injected for test purposes

function getFromLocalStorage(key) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

  if (localStorageAvailable()) {
    var item = safeJSONParse(localStorage.getItem(key));
    var expireTs = item && item.expireTs;

    if (expireTs && expireTs <= date) {
      remove(key);
      return null;
    }

    return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(item, 'value') || null;
  }

  return null;
}
function remove(key) {
  if (localStorageAvailable()) {
    localStorage.removeItem(key);
  }
}
function clearLocalStorage() {
  if (localStorageAvailable()) {
    localStorage.clear();
  }
}

/***/ }),

/***/ "4GeQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "4a5f":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"), __webpack_require__("i3c9"), __webpack_require__("0Hfl"), __webpack_require__("Cf/K"), __webpack_require__("heQk"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),

/***/ "5x5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _iterableToArray; });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ "6jSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ QUICK_LOGIN_QUERY_PARAM; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ isCxoSellerContext; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ buildSigninUrl; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ buildChangePassword; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ buildFacebookConnectUrl; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ buildStepupUrl; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ buildWechatConnectUrl; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ buildSellerSigninUrl; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ buildSignupUrl; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ buildSignoutUrl; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ buildErrorUrl; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ redirectOnLoginPage; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ hasAuthResponseError; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ hasNotFoundError; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ createDocumentUrl; });

// UNUSED EXPORTS: redirectToOidc

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/graphql-client/cacheFront.js
var cacheFront = __webpack_require__("ESA2");

// CONCATENATED MODULE: ./src/client/tracking/google-analytics/googleAnalytics.js
var getGa = function getGa() {
  return  true && window.ga ? window.ga : null;
};

var getTracker = function getTracker() {
  var ga = getGa();

  if (ga) {
    return ga.hasOwnProperty('getAll') ? ga.getAll()[0] : null;
  }

  return null;
};

var getClientID = function getClientID() {
  var tracker = getTracker();
  return tracker ? tracker.get('clientId') : null;
};


// CONCATENATED MODULE: ./src/utils/ple-utils/index.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var QUICK_LOGIN_QUERY_PARAM = 'bookingGM';
function isCxoSellerContext(queryParameters) {
  return queryParameters ? queryParameters.includes('cxo_neolid=') : false;
}

function getRedirectUri(redirectUri) {
  var pathAccount = routeBuilder["a" /* buildUrl */]('account');
  if (redirectUri) return redirectUri;
  return true ? new URI_default.a(dist["windowWrapper"].getOrigin()).path(pathAccount).toString() : undefined;
}

function getHomeUri() {
  var pathAccount = routeBuilder["a" /* buildUrl */]('home');
  return true ? new URI_default.a(dist["windowWrapper"].getOrigin()).path(pathAccount).toString() : undefined;
}

function getRedirectUriError(redirectURIError) {
  var pathError = routeBuilder["a" /* buildUrl */]('error');
  if (redirectURIError) return redirectURIError;
  return true ? new URI_default.a(dist["windowWrapper"].getOrigin()).path(pathError).toString() : undefined;
}

function getLocaleQueryParams(redirectUri) {
  var redirectUriQueryParameters;

  if (true) {
    redirectUriQueryParameters = URI_default.a.parseQuery(dist["windowWrapper"].getLocationPart('search'));
  } else {}

  var locale = Object(lodash["get"])(redirectUriQueryParameters, 'locale');
  return locale ? {
    locale: locale
  } : {};
}

function getOidcQuery(_ref) {
  var locale = _ref.locale,
      redirectUri = _ref.redirectUri,
      redirectURIError = _ref.redirectURIError,
      state = _ref.state,
      provider = _ref.provider,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isQuickLoginFirs = _ref.isQuickLoginFirst,
      isQuickLoginFirst = _ref$isQuickLoginFirs === void 0 ? false : _ref$isQuickLoginFirs;
  return URI_default.a.buildQuery({
    client_id: isSeller ? config_default.a.get('oidc.seller.client_id') : config_default.a.get('oidc.client_id'),
    redirect_uri: isSeller ? config_default.a.get('oidc.seller.proxy.signin_redirect_uri') : config_default.a.get('oidc.proxy.signin_redirect_uri'),
    response_type: config_default.a.get('oidc.response_type'),
    state: dist["oidc"].toUriEncodedState({
      redirect_uri: getRedirectUri(redirectUri),
      home_uri: getHomeUri(),
      redirect_uri_on_error: getRedirectUriError(redirectURIError),
      state: dist["oidc"].toUriEncodedState(state)
    }),
    scope: config_default.a.get('oidc.scope'),
    locale: locale,
    provider: provider || (isQuickLoginFirst ? QUICK_LOGIN_QUERY_PARAM : undefined),
    visitorGUID: getClientID()
  });
}

function buildSigninUrl(_ref2) {
  var locale = _ref2.locale,
      redirectUri = _ref2.redirectUri,
      redirectURIError = _ref2.redirectURIError,
      state = _ref2.state,
      provider = _ref2.provider,
      isQuickLoginFirst = _ref2.isQuickLoginFirst;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.authorize')).query(getOidcQuery({
    locale: locale,
    redirectUri: redirectUri,
    redirectURIError: redirectURIError,
    state: state,
    provider: provider,
    isQuickLoginFirst: isQuickLoginFirst
  })).toString();
}
function buildChangePassword(_ref3) {
  var redirectUri = _ref3.redirectUri,
      locale = _ref3.locale;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.changePassword')).query(getOidcQuery({
    redirectUri: redirectUri,
    locale: locale
  })).toString();
}
function buildFacebookConnectUrl(_ref4) {
  var locale = _ref4.locale,
      redirectUri = _ref4.redirectUri,
      state = _ref4.state;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.facebookConnect')).query(getOidcQuery({
    locale: locale,
    redirectUri: redirectUri,
    state: state
  })).toString();
}
function buildStepupUrl(_ref5) {
  var locale = _ref5.locale,
      state = _ref5.state,
      redirectURIError = _ref5.redirectURIError,
      redirectUri = _ref5.redirectUri;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.stepup')).query(getOidcQuery({
    locale: locale,
    redirectUri: redirectUri,
    redirectURIError: redirectURIError,
    state: state
  })).toString();
}
function buildWechatConnectUrl(_ref6) {
  var locale = _ref6.locale,
      redirectUri = _ref6.redirectUri,
      state = _ref6.state;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.wechatConnect')).query(getOidcQuery({
    locale: locale,
    redirectUri: redirectUri,
    state: state
  })).toString();
}
function buildSellerSigninUrl(_ref7) {
  var redirectUri = _ref7.redirectUri,
      locale = _ref7.locale,
      isCmta = _ref7.isCmta;
  return new URI_default.a(config_default.a.get('oidc.seller.host')).path(isCmta ? config_default.a.get('oidc.seller.partner_login') : config_default.a.get('oidc.seller.authorize')).query(getOidcQuery({
    redirectUri: redirectUri,
    isSeller: true,
    locale: locale
  })).toString();
}
function buildSignupUrl(_ref8) {
  var redirectUri = _ref8.redirectUri,
      locale = _ref8.locale;
  return new URI_default.a(config_default.a.get('oidc.host')).path(config_default.a.get('oidc.signup')).query(getOidcQuery({
    redirectUri: redirectUri,
    locale: locale
  })).toString();
}
function buildSignoutUrl() {
  var visitorGUIDDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var redirectPath = arguments.length > 1 ? arguments[1] : undefined;
  var isSeller = arguments.length > 2 ? arguments[2] : undefined;

  if (true) {
    var guid = getClientID();
    var visitorGUID = !visitorGUIDDisabled && guid ? {
      visitorGUID: guid
    } : {};

    var queryParameters = _objectSpread(_objectSpread(_objectSpread({}, getLocaleQueryParams()), visitorGUID), {}, {
      isSeller: isSeller
    });

    if (redirectPath) {
      var redirectUri = new URI_default.a(dist["windowWrapper"].getOrigin()).path(redirectPath).query(dist["windowWrapper"].getLocationPart('search')).hash(window.location.hash).toString(); // $FlowFixMe

      queryParameters.redirectUri = redirectUri;
    }

    var url = routeBuilder["a" /* buildUrl */]('signout', {}, !Object(lodash["isEmpty"])(queryParameters) ? queryParameters : null);
    return url;
  }

  return null;
}
function buildErrorUrl(currentUri, locale) {
  return new URI_default.a(currentUri).path(routeBuilder["a" /* buildUrl */]('error')).query({
    lang: locale
  }).hash('').toString();
}
function redirectOnLoginPage(_ref9) {
  var locale = _ref9.locale,
      redirectPath = _ref9.redirectPath,
      state = _ref9.state,
      isSeller = _ref9.isSeller,
      isQuickLoginFirst = _ref9.isQuickLoginFirst;

  if (true) {
    var redirectUri = new URI_default.a(dist["windowWrapper"].getOrigin()).path(redirectPath).query(dist["windowWrapper"].getLocationPart('search')).hash(dist["windowWrapper"].getLocationPart('hash')).toString();
    Object(cacheFront["a" /* clearAllCacheFront */])();
    dist["windowWrapper"].setLocation(isSeller || isCxoSellerContext(dist["windowWrapper"].getLocationPart('search')) ? buildSellerSigninUrl({
      locale: locale,
      redirectUri: redirectUri
    }) : buildSigninUrl({
      locale: locale,
      redirectUri: redirectUri,
      state: state,
      isQuickLoginFirst: isQuickLoginFirst
    }));
  }
}

function hasStatus(httpResponse, statusCode) {
  var errors = Object(lodash["get"])(httpResponse, 'errors', []) || [];
  return Array.isArray(errors) ? errors.some(function (err) {
    return err.statusCode === statusCode;
  }) : false;
}

function hasAuthResponseError(httpResponse) {
  return hasStatus(httpResponse, 401);
}
function hasNotFoundError(httpResponse) {
  return hasStatus(httpResponse, 404);
}
function redirectToOidc(locale) {
  redirectOnLoginPage({
    redirectPath: new URI_default.a(dist["windowWrapper"].getLocation()).pathname(),
    locale: locale
  });
}
function createDocumentUrl(_ref10) {
  var customerNeolaneId = _ref10.customerNeolaneId,
      neolaneId = _ref10.neolaneId,
      userBooking = _ref10.userBooking,
      file = _ref10.file,
      locale = _ref10.locale,
      origin = _ref10.origin;
  var gqlHost = config_default.a.get('graphql.host');
  var customerId = customerNeolaneId || neolaneId;
  var isSeller = !!customerNeolaneId; // TODO use buildErrorUrl

  var redirectUrlError = "".concat(new URI_default.a(origin).origin(), "/error");
  return "".concat(gqlHost).concat(gqlHost && gqlHost.charAt(gqlHost.length - 1) === '/' ? '' : '/', "documents/").concat(String(customerId), "/").concat(Object(lodash["get"])(userBooking, 'information.bookingId'), "/").concat(file.id, "/?redirect_url_error=").concat(redirectUrlError, "&locale=").concat(locale, "&cxo=").concat(isSeller ? 'true' : 'false');
}

/***/ }),

/***/ "72zh":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "77dk":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ "829J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EVENT_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return VIRTUAL_PAGE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GA_DEFAULT_PAYLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BE_OPTION_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BE_OPTION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BE_TRACKING; });
/* unused harmony export BE_MORE_ACCOMMODATIONS */
/* unused harmony export BE_MODIFY_TRANSPORT */
/* unused harmony export BE_MODIFY_TRANSPORT_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONNECTION_STATUS_LOGGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONNECTION_STATUS_QUICK_LOGGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONNECTION_STATUS_NOT_LOGGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PLE_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PLE_QUICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PLE_QUICK_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PLE_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SEARCH_LABEL_GA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SHOPPING_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SHOPPING_LAST_VISITED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHOPPING_LAST_VISITED_PRODUCTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SUMMER_DATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SUMMER_DATE_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PROPOSAL_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return STATIC_PAGE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return WEB_CALLBACK_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return WEB_CALLBACK_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MEETING_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OFFER_PUSH; });
var EVENT_GA = 'eventGA';
var VIRTUAL_PAGE_LOAD = 'virtualPageLoadingDataLayer';
var GA_DEFAULT_PAYLOAD = {
  event: EVENT_GA,
  valueGA: 0,
  nonInteraction: 0
};
var BE = 'Booking Engine';
var BE_OPTION_CONFIRMATION = 'BE_option_confirmation';
var BE_OPTION_ERROR = 'BE_option_error';
var BE_TRACKING = 'trackingBE';
var BE_MORE_ACCOMMODATIONS = 'BE_moreRooms';
var BE_MODIFY_TRANSPORT = 'BE_modifyTransport';
var BE_MODIFY_TRANSPORT_ERROR = 'BE_modifyTransportError';
var CONNECTION_STATUS_LOGGED = 'alreadyLogged';
var CONNECTION_STATUS_QUICK_LOGGED = 'quickLogged';
var CONNECTION_STATUS_NOT_LOGGED = 'notLogged';
var PLE = 'PLE';
var PLE_OPTION = 'PLE_option';
var PLE_QUICK = 'PLE_quick';
var PLE_QUICK_OPTION = 'PLE_quick_option';
var PLE_TRACKING = 'trackingPLE';
var SEARCH_LABEL_GA_MAP = {
  activity: 'activities',
  area: 'destination',
  country: 'destination',
  edito: 'editorial',
  none: 'searchCTA',
  resort: 'village'
};
var SHOPPING_TRACKING = 'trackingSHOP';
var SHOPPING_LAST_VISITED_PRODUCTS = 'SHOP_lastVisitedProducts';
var SHOPPING_LAST_VISITED_PRODUCTS_NUMBER = 10;
var SUMMER_DATE_START = 501;
var SUMMER_DATE_END = 1102;
var PROPOSAL_CATEGORIES = {
  '000017': 'club',
  // club
  '000048': 'club',
  // club seaside view
  '000061': 'superior',
  // superior
  '000018': 'deluxe',
  // deluxe
  '000039': 'deluxe',
  // deluxe zen
  '000047': 'deluxe',
  // deluxe seaside view
  '000056': 'deluxe',
  // Deluxe Exclusive
  '000019': 'suite',
  // suite
  '000020': 'suite' // suite 5 tridents

};
var STATIC_PAGE_TYPES = {
  BE: 'bookingEngine',
  PLE: 'ple',
  PLE_PAYMENT_CONFIRMATION: 'ple-payment-confirmation',
  SHOPPING_HOME: 'home',
  SHOPPING_NEWSLETTER: 'newsletter',
  SHOPPING_PREBOOKING: 'prebooking',
  SHOPPING_SEARCH: 'search',
  SHOPPING_SITEPLAN: 'siteplan',
  SHOPPING_QUICKSEARCH_UNAVALIABILITY: 'shopping_quickSearch_unavailability'
};
var WEB_CALLBACK_OPEN = 'webCallBack';
var WEB_CALLBACK_SUBMIT = 'webCallBack_validate';
var MEETING_EVENT = {
  REQUEST: 'requestForm',
  SEND_REQUEST_SUCCESS: 'CTASendRequest',
  SEND_REQUEST_ERROR: 'CTASendRequest_error'
};
var OFFER_PUSH = {
  ACTION: 'main_push_offers'
};

/***/ }),

/***/ "8dj6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");
var bind = __webpack_require__("vfGT");
var Axios = __webpack_require__("YsDt");
var defaults = __webpack_require__("dyNj");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("FYay");
axios.CancelToken = __webpack_require__("J1qw");
axios.isCancel = __webpack_require__("WBY7");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("IOAS");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "97Jx":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "9NGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setInSessionStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFromSessionStorage; });
/* unused harmony export clearSessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeFromSessionStorage; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");

/* eslint-env browser */

function safeJSONParse(o) {
  try {
    return JSON.parse(o);
  } catch (e) {
    return null;
  }
}

function ensureSessionStorage() {
  return true;
}

function getParsedEntry(_ref) {
  var _ref2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [key, safeJSONParse(value)];
}

function setInSessionStorage(key, value) {
  return ensureSessionStorage() && sessionStorage.setItem(key, JSON.stringify(value));
}
function getEntries() {
  return ensureSessionStorage() ? Object.entries(sessionStorage).map(getParsedEntry) : [];
}
function getFromSessionStorage(key) {
  return ensureSessionStorage() && key ? safeJSONParse(sessionStorage.getItem(key)) : null;
}
function clearSessionStorage() {
  return ensureSessionStorage() && sessionStorage.clear();
}
function removeFromSessionStorage(key) {
  return ensureSessionStorage() && key && sessionStorage.removeItem(key);
}

/***/ }),

/***/ "Ay6X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");
var settle = __webpack_require__("Soal");
var buildURL = __webpack_require__("Q2eF");
var parseHeaders = __webpack_require__("eGgp");
var isURLSameOrigin = __webpack_require__("0zX2");
var createError = __webpack_require__("pQXz");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("yOYy");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ( true &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("ym5Q");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "BP9p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "BtTt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");
var transformData = __webpack_require__("4GeQ");
var isCancel = __webpack_require__("WBY7");
var defaults = __webpack_require__("dyNj");
var isAbsoluteURL = __webpack_require__("BP9p");
var combineURLs = __webpack_require__("E7j9");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "CcNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getName */
/* unused harmony export getGqlName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Oc", function() { return PAGE_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pc", function() { return PAGE_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Qc", function() { return PAGE_DYNAMIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rc", function() { return PAGE_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sc", function() { return PAGE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tc", function() { return PAGE_SITEMAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Uc", function() { return PAGE_SITEPLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vc", function() { return PAGE_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return LINE_COMMON_COUNTRY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return LINE_COMMON_COUNTRY_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return LINE_COMMON_COUNTRY_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return LINE_COMMON_COUNTRY_POI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return LINE_COMMON_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return LINE_COMMON_EVENT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return LINE_COMMON_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return LINE_COMMON_INSTAGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return LINE_COMMON_LAST_SEEN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return LINE_COMMON_PRODUCT_GRID_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return LINE_COMMON_PRODUCT_GRID_IDS_WITH_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lb", function() { return LINE_COMMON_PRODUCT_GRID_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mb", function() { return LINE_COMMON_PRODUCT_GRID_THUMBNAIL_TRADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nb", function() { return LINE_COMMON_PRODUCT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ob", function() { return LINE_COMMON_TEASER_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pb", function() { return LINE_COMMON_THEMATIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Qb", function() { return LINE_COMMON_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tb", function() { return LINE_OFFER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ub", function() { return LINE_OFFER_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vb", function() { return LINE_OFFER_LEGAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Wb", function() { return LINE_OFFER_PRODUCT_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xb", function() { return LINE_OFFER_SEO; });
/* unused harmony export LINE_OFFER_TRACKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Yb", function() { return LINE_PRODUCT_ACCESS_AND_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Zb", function() { return LINE_PRODUCT_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ac", function() { return LINE_PRODUCT_ACCOMMODATIONS_STREETVIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bc", function() { return LINE_PRODUCT_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cc", function() { return LINE_PRODUCT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dc", function() { return LINE_PRODUCT_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ec", function() { return LINE_PRODUCT_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fc", function() { return LINE_PRODUCT_CHILDCARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gc", function() { return LINE_PRODUCT_COMMUNITY_QUESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hc", function() { return LINE_PRODUCT_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ic", function() { return LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jc", function() { return LINE_PRODUCT_FLASH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kc", function() { return LINE_PRODUCT_IMAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lc", function() { return LINE_PRODUCT_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mc", function() { return LINE_PRODUCT_INFORMATION_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nc", function() { return LINE_PRODUCT_INSTAGRAM_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "oc", function() { return LINE_PRODUCT_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pc", function() { return LINE_PRODUCT_MEETING_ROOM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qc", function() { return LINE_PRODUCT_MULTIMEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rc", function() { return LINE_PRODUCT_MUST_TRY_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sc", function() { return LINE_PRODUCT_PRICE_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tc", function() { return LINE_PRODUCT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uc", function() { return LINE_PRODUCT_PRICE_TICKET_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vc", function() { return LINE_PRODUCT_QUOTATION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wc", function() { return LINE_PRODUCT_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xc", function() { return LINE_PRODUCT_RELATED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yc", function() { return LINE_PRODUCT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zc", function() { return LINE_PRODUCT_SEO_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ac", function() { return LINE_PRODUCT_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bc", function() { return LINE_PRODUCT_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cc", function() { return LINE_PRODUCT_STREET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dc", function() { return LINE_PRODUCT_STRENGTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ec", function() { return LINE_PRODUCT_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fc", function() { return LINE_PRODUCT_TRIPADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gc", function() { return LINE_PRODUCT_WELLNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rb", function() { return LINE_CRUISE_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sb", function() { return LINE_CRUISE_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hc", function() { return LINE_TOUR_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ic", function() { return LINE_TOUR_PRACTICAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jc", function() { return LINE_TOUR_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bd", function() { return STATE_PRODUCT_ALL_INCLUSIVE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cd", function() { return STATE_PRODUCT_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dd", function() { return STATE_PRODUCT_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fd", function() { return STATE_PRODUCT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ed", function() { return STATE_PRODUCT_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gd", function() { return STATE_SEARCH_FACETING_TOP_COUNTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hd", function() { return STATE_SEARCH_OFFSET_SELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jd", function() { return STATE_SEARCH_PRODUCT_CHILDCARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kd", function() { return STATE_SEARCH_PRODUCT_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Id", function() { return STATE_SEARCH_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ld", function() { return STATE_SEARCH_PRODUCT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nd", function() { return WIDGET_CRUISE_BOOKING_CALL_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Od", function() { return WIDGET_EVENT_FORM_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pd", function() { return WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Qd", function() { return WIDGET_QUOTATION_FORM_SUBMIT; });
/* unused harmony export WIDGET_QUOTATION_FORM_TRACK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rd", function() { return WIDGET_WEBCALLBACK_OPENING_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sd", function() { return WIDGET_WEBCALLBACK_SCHEDULE_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_GET_COMMON_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_GET_FACEBOOK_CONNECT_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hd", function() { return PRODUCT_GET_PACKAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_GET_BOOKING_I18N; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_IMMERSIVE_PICTURES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CUSTOMER_ACCOUNT_GET_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CUSTOMER_ACCOUNT_GET_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CUSTOMER_ACCOUNT_GET_PROFILE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CUSTOMER_ACCOUNT_GET_PROFILE_NEWSLETTER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CUSTOMER_ACCOUNT_GET_SEARCHES; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_CMS_DATA */
/* unused harmony export CUSTOMER_ACCOUNT_GET_CMS_DATA_ACTIVITIES_SECTION */
/* unused harmony export CUSTOMER_ACCOUNT_GET_DATA_ACTIVITIES_SECTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_GREAT_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_BOOKING_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_PREPAYMENT; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_CMS_DATA_PREPAREMYSTAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CUSTOMER_ACCOUNT_GET_CMS_DATA_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CUSTOMER_ACCOUNT_SPONSORSHIP_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CUSTOMER_ACCOUNT_GET_SPONSORSHIP_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CUSTOMER_ACCOUNT_GET_TRAVEL_COMPANIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CUSTOMER_ACCOUNT_GM_GET_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CUSTOMER_ACCOUNT_GM_GET_USER_LOYALTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CUSTOMER_ACCOUNT_GET_CMS_CONTENT_TRANSFER; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_TRANSFERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CUSTOMER_ACCOUNT_GET_TRANSFER_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CUSTOMER_ACCOUNT_SUBMIT_FORM_SPONSOR_A_FRIEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CUSTOMER_ACCOUNT_UPDATE_PASSPORT; });
/* unused harmony export CUSTOMER_ACCOUNT_UPDATE_PASSWORD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CUSTOMER_ACCOUNT_UPDATE_PERSONAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CUSTOMER_ACCOUNT_GET_FURTHER_INFORMATION; });
/* unused harmony export CUSTOMER_ACCOUNT_VIEW_RESOLVER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CUSTOMER_ACCOUNT_PROFILE_VIEW_RESOLVER; });
/* unused harmony export CUSTOMER_ACCOUNT_DASHBOARD_RESOLVER */
/* unused harmony export CUSTOMER_ACCOUNT_SEARCHES_RESOLVER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CUSTOMER_ACCOUNT_GET_CMS_CONTENT_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CUSTOMER_ACCOUNT_GET_CMS_CONTENT_QUICK_DASHBOARD; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_CMS_CONTENT */
/* unused harmony export CUSTOMER_ACCOUNT_GET_DASHBOARD_CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_CURRENT_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_SPONSORSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CUSTOMER_ACCOUNT_GET_DASHBOARD_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CUSTOMER_ACCOUNT_GET_QUICK_DASHBOARD_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CUSTOMER_ACCOUNT_GET_VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CUSTOMER_ACCOUNT_GET_VOUCHERS_CMS_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CUSTOMER_ACCOUNT_GET_BOOKING_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CUSTOMER_ACCOUNT_GET_BOOKING_CHILDCARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CUSTOMER_ACCOUNT_GET_BOOKING_CART; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_BOOKING_RENTALS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CUSTOMER_ACCOUNT_GET_AVAILABLE_RENTALS; });
/* unused harmony export CUSTOMER_ACCOUNT_GET_RENTALS_CMS_CONTENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM; });
/* unused harmony export CUSTOMER_BOOKING_AUTHORIZATION_NOTIFY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CUSTOMER_BOOKING_AUTHORIZATION_REDIRECT; });
/* unused harmony export CUSTOMER_BOOKING_GET_ACTIVITIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CUSTOMER_BOOKING_GET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return CUSTOMER_BOOKING_GET_STAY_FORMALITIES; });
/* unused harmony export CUSTOMER_BOOKING_GET_AVAILABLE_RENTAL_EQUIPMENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return CUSTOMER_FIDELITY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CUSTOMER_BOOKING_GET_CUSTOMERS; });
/* unused harmony export CUSTOMER_BOOKING_GET_DASHBOARD_DATA */
/* unused harmony export CUSTOMER_BOOKING_GET_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CUSTOMER_BOOKING_GET_DOCUMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return CUSTOMER_BOOKING_GET_PRICE_AND_PAYMENT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return CUSTOMER_BOOKING_GET_TRANSPORT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT; });
/* unused harmony export CUSTOMER_BOOKING_PREPARE_MY_STAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return CUSTOMER_BOOKING_PREPARE_MY_STAY_GET_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return CUSTOMER_BOOKING_PYR_ROOM_ONLY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return CUSTOMER_BOOKING_PYR_GET_GEO_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return CUSTOMER_BOOKING_PYR_AGENCY_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return CUSTOMER_BOOKING_PYR_GET_RESORT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return CUSTOMER_BOOKING_PYR_GET_RESORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return CUSTOMER_BOOKING_PYR_GET_ROOM_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return CUSTOMER_BOOKING_PYR_GET_ROOM_SELECTION_AGENCY; });
/* unused harmony export CUSTOMER_BOOKING_PYR_PAYMENT_BUTTON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return CUSTOMER_BOOKING_PYR_PUSH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return CUSTOMER_BOOKING_PYR_MAP_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return CUSTOMER_BOOKING_PYR_MAP_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return CUSTOMER_BOOKING_PYR_AGENCY_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return CUSTOMER_BOOKING_PYR_RESORT_FORM_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return CUSTOMER_BOOKING_PYR_RESORT_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return CUSTOMER_BOOKING_UPDATE_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return CUSTOMER_BOOKING_UPDATE_TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return CUSTOMER_BOOKING_OPTION_CONFIRMATION_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return CUSTOMER_BY_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CRITERIA_OFFSETSELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lc", function() { return NEWSLETTER_GET_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mc", function() { return NEWSLETTER_SUBMIT_SUBSCRIPTION; });
/* unused harmony export NEWSLETTER_SUBMIT_SUBSCRIPTION_QUOTATION_FORM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nc", function() { return NEWSLETTER_SUBSCRIPTION_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kc", function() { return NEWSLETTER_CONFIRM_SUBSCRIPTION_VIEW_RESOLVER; });
/* unused harmony export NEWSLETTER_SUBMIT_QUOTATION_FORM */
/* unused harmony export PAYMENT_APPROVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Xc", function() { return PAYMENT_CONFIRMATION_GET_BOOKING_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Yc", function() { return PAYMENT_CONFIRMATION_GET_TRACKING_DATA; });
/* unused harmony export PAYMENT_GET_STATUS */
/* unused harmony export PAYMENT_INFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ad", function() { return PAYMENT_INIT; });
/* unused harmony export PAYMENT_NOTIFY_MUTATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gd", function() { return PAYMENT_STATUS_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cd", function() { return PAYMENT_POLLING_GET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dd", function() { return PAYMENT_PRE_GET_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ed", function() { return PAYMENT_PRE_GET_FORM_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fd", function() { return PAYMENT_REDIRECT; });
/* unused harmony export PAYMENT_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Wc", function() { return PAYMENT_CLEAN_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Zc", function() { return PAYMENT_CONFIRMATION_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bd", function() { return PAYMENT_NOTIFICATION_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "id", function() { return PROPOSAL_ACCOMMODATION_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "md", function() { return PROPOSAL_ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "od", function() { return PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pd", function() { return PROPOSAL_GET_ADDITIONAL_TRANSPORT; });
/* unused harmony export PROPOSAL_ADD_RENTAL_EQUIPMENT */
/* unused harmony export PROPOSAL_REMOVE_RENTAL_EQUIPMENT */
/* unused harmony export PROPOSAL_GET_AVAILABLE_RENTAL_EQUIPMENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qd", function() { return PROPOSAL_GET_BY_ID; });
/* unused harmony export PROPOSAL_GET_ONE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sd", function() { return PROPOSAL_GET_SEVERAL; });
/* unused harmony export PROPOSAL_LINE_BOOKING_SUMMARY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "td", function() { return PROPOSAL_LINE_CONFIRMATION; });
/* unused harmony export PROPOSAL_LINE_PAYMENT_INFO */
/* unused harmony export PROPOSAL_LINE_PAYMENT_INFO_TRACKING */
/* unused harmony export PROPOSAL_LINE_PRICE_HEADER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ud", function() { return PROPOSAL_SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wd", function() { return PROPOSAL_UPDATE; });
/* unused harmony export PROPOSAL_UPDATE_TRANSFER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zd", function() { return PROPOSAL_USE_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rd", function() { return PROPOSAL_GET_SCHEDULE_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xd", function() { return PROPOSAL_UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yd", function() { return PROPOSAL_UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nd", function() { return PROPOSAL_DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vd", function() { return PROPOSAL_SWITCH_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jd", function() { return PROPOSAL_ADDITIONAL_SERVICES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ld", function() { return PROPOSAL_ADDITIONAL_SERVICES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kd", function() { return PROPOSAL_ADDITIONAL_SERVICES_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPARATOR_VIEW_RESOLVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ad", function() { return SELLER_PREBOOKING_FORM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Md", function() { return STREET_VIEW_GET_SEVERAL; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");

var GRAPHQL = 'GRAPHQL';
var DOMAINS = {
  BOOKING: 'BOOKING',
  COMMON: 'COMMON',
  COMPARATOR: 'COMPARATOR',
  CORE: 'CORE',
  CRUISE: 'CRUISE',
  CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
  CUSTOMER_BOOKING: 'CUSTOMER_BOOKING',
  LINE: 'LINE',
  NEWSLETTER: 'NEWSLETTER',
  OFFER: 'OFFER',
  PAGE: 'PAGE',
  PAYMENT: 'PAYMENT',
  PRODUCT: 'PRODUCT',
  PROPOSAL: 'PROPOSAL',
  SEARCH: 'SEARCH',
  SELLER: 'SELLER',
  STATE: 'STATE',
  STREET_VIEW: 'STREET_VIEW',
  TOUR: 'TOUR',
  WIDGET: 'WIDGET'
};
var COMMON = DOMAINS.COMMON,
    CORE = DOMAINS.CORE,
    CRUISE = DOMAINS.CRUISE,
    CUSTOMER_ACCOUNT = DOMAINS.CUSTOMER_ACCOUNT,
    CUSTOMER_BOOKING = DOMAINS.CUSTOMER_BOOKING,
    LINE = DOMAINS.LINE,
    NEWSLETTER = DOMAINS.NEWSLETTER,
    OFFER = DOMAINS.OFFER,
    PAGE = DOMAINS.PAGE,
    PAYMENT = DOMAINS.PAYMENT,
    PRODUCT = DOMAINS.PRODUCT,
    PROPOSAL = DOMAINS.PROPOSAL,
    SEARCH = DOMAINS.SEARCH,
    STATE = DOMAINS.STATE,
    STREET_VIEW = DOMAINS.STREET_VIEW,
    TOUR = DOMAINS.TOUR,
    WIDGET = DOMAINS.WIDGET; // Helpers

function getName(path) {
  return path.filter(Boolean).map(function (x) {
    return x.toUpperCase();
  }).join('|');
}
function getGqlName(path) {
  return getName([GRAPHQL].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(path)));
} // PAGES

var PAGE_404 = getGqlName([PAGE, '404']);
var PAGE_ARTICLE = getGqlName([PAGE, 'ARTICLE']);
var PAGE_DYNAMIC = getGqlName([PAGE, 'DYNAMIC']);
var PAGE_HOME = getGqlName([PAGE, 'HOME']);
var PAGE_SEARCH = getGqlName([PAGE, 'SEARCH']);
var PAGE_SITEMAP = getGqlName([PAGE, 'SITEMAP']);
var PAGE_SITEPLAN = getGqlName([PAGE, 'SITEPLAN']);
var PAGE_THEME = getGqlName([PAGE, 'THEME']); // LINES

var LINE_COMMON_COUNTRY_EVENTS = getGqlName([LINE, COMMON, 'COUNTRY_EVENTS']);
var LINE_COMMON_COUNTRY_INFOS = getGqlName([LINE, COMMON, 'COUNTRY_INFOS']);
var LINE_COMMON_COUNTRY_INTRODUCTION = getGqlName([LINE, COMMON, 'COUNTRY_INTRODUCTION']);
var LINE_COMMON_COUNTRY_POI = getGqlName([LINE, COMMON, 'COUNTRY_POI']);
var LINE_COMMON_DESTINATIONS = getGqlName([LINE, COMMON, 'DESTINATIONS']);
var LINE_COMMON_EVENT_FORM = getGqlName([LINE, COMMON, 'EVENT_FORM']);
var LINE_COMMON_IMMERSIVE = getGqlName([LINE, COMMON, 'IMMERSIVE']);
var LINE_COMMON_INSTAGRAM = getGqlName([LINE, COMMON, 'INSTAGRAM']);
var LINE_COMMON_LAST_SEEN_PRODUCTS = getGqlName([LINE, COMMON, 'LAST_SEEN_PRODUCTS']);
var LINE_COMMON_PRODUCT_GRID_IDS = getGqlName([LINE, COMMON, 'PRODUCT_GRID_IDS']);
var LINE_COMMON_PRODUCT_GRID_IDS_WITH_OFFER = getGqlName([LINE, COMMON, 'PRODUCT_GRID_IDS_WITH_OFFER']);
var LINE_COMMON_PRODUCT_GRID_PRODUCTS = getGqlName([LINE, COMMON, 'PRODUCT_GRID_PRODUCTS']);
var LINE_COMMON_PRODUCT_GRID_THUMBNAIL_TRADS = getGqlName([LINE, COMMON, 'PRODUCT_GRID_THUMBNAIL_TRADS']);
var LINE_COMMON_PRODUCT_TAGS = getGqlName([LINE, COMMON, 'PRODUCT_TAGS']);
var LINE_COMMON_TEASER_CARDS = getGqlName([LINE, COMMON, 'TEASER_CARDS']);
var LINE_COMMON_THEMATIC = getGqlName([LINE, COMMON, 'THEMATIC']);
var LINE_COMMON_TRACKING = getGqlName([LINE, COMMON, 'TRACKING']);
var LINE_OFFER_DESCRIPTION = getGqlName([LINE, OFFER, 'DESCRIPTION']);
var LINE_OFFER_GRID = getGqlName([LINE, OFFER, 'GRID']);
var LINE_OFFER_LEGAL_INFORMATION = getGqlName([LINE, OFFER, 'LEGAL_INFORMATION']);
var LINE_OFFER_PRODUCT_FILTER = getGqlName([LINE, OFFER, 'PRODUCT_FILTER']);
var LINE_OFFER_SEO = getGqlName([LINE, OFFER, 'SEO']);
var LINE_OFFER_TRACKING = getGqlName([LINE, OFFER, 'TRACKING']);
var LINE_PRODUCT_ACCESS_AND_MAP = getGqlName([LINE, PRODUCT, 'ACCESS_AND_MAP']);
var LINE_PRODUCT_ACCOMMODATIONS = getGqlName([LINE, PRODUCT, 'ACCOMMODATIONS']);
var LINE_PRODUCT_ACCOMMODATIONS_STREETVIEWS = getGqlName([LINE, PRODUCT, 'ACCOMMODATIONS_STREETVIEWS']);
var LINE_PRODUCT_ACTIVITIES = getGqlName([LINE, PRODUCT, 'ACTIVITIES']);
var LINE_PRODUCT_BARS = getGqlName([LINE, PRODUCT, 'BARS']);
var LINE_PRODUCT_BOOKING = getGqlName([LINE, PRODUCT, 'BOOKING']);
var LINE_PRODUCT_BREADCRUMB = getGqlName([LINE, PRODUCT, 'BREADCRUMB']);
var LINE_PRODUCT_CHILDCARE = getGqlName([LINE, PRODUCT, 'CHILDCARE']);
var LINE_PRODUCT_COMMUNITY_QUESTIONS = getGqlName([LINE, PRODUCT, 'COMMUNITY_QUESTIONS']);
var LINE_PRODUCT_DESTINATIONS = getGqlName([LINE, PRODUCT, 'DESTINATIONS']);
var LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE = getGqlName([LINE, PRODUCT, 'EXCLUSIVE_COLLECTION_SPACE']);
var LINE_PRODUCT_FLASH_INFO = getGqlName([LINE, PRODUCT, 'FLASH_INFO']);
var LINE_PRODUCT_IMAGE_MAP = getGqlName([LINE, PRODUCT, 'IMAGE_MAP']);
var LINE_PRODUCT_IMMERSIVE = getGqlName([LINE, PRODUCT, 'IMMERSIVE']);
var LINE_PRODUCT_INFORMATION_SUMMARY = getGqlName([LINE, PRODUCT, 'INFORMATION_SUMMARY']);
var LINE_PRODUCT_INSTAGRAM_GRID = getGqlName([LINE, PRODUCT, 'INSTAGRAM_GRID']);
var LINE_PRODUCT_INTRODUCTION = getGqlName([LINE, PRODUCT, 'INTRODUCTION']);
var LINE_PRODUCT_MEETING_ROOM_INFO = getGqlName([LINE, PRODUCT, 'MEETING_ROOM_INFO']);
var LINE_PRODUCT_MULTIMEDIA = getGqlName([LINE, PRODUCT, 'MULTIMEDIA']);
var LINE_PRODUCT_MUST_TRY_EXPERIENCES = getGqlName([LINE, PRODUCT, 'MUST_TRY_EXPERIENCES']);
var LINE_PRODUCT_PRICE_REMOTE = getGqlName([LINE, PRODUCT, 'PRICE_REMOTE']);
var LINE_PRODUCT_PRICE_TICKET = getGqlName([LINE, PRODUCT, 'PRICE_TICKET']);
var LINE_PRODUCT_PRICE_TICKET_CUSTOM = getGqlName([LINE, PRODUCT, 'PRICE_TICKET_CUSTOM']);
var LINE_PRODUCT_QUOTATION_FORM = getGqlName([LINE, PRODUCT, 'QUTATION_FORM']);
var LINE_PRODUCT_RECOMMENDATIONS = getGqlName([LINE, PRODUCT, 'RECOMMENDATIONS']);
var LINE_PRODUCT_RELATED_PRODUCTS = getGqlName([LINE, PRODUCT, 'RELATED_PRODUCTS']);
var LINE_PRODUCT_RESTAURANTS = getGqlName([LINE, PRODUCT, 'RESTAURANTS']);
var LINE_PRODUCT_SEO_TITLE = getGqlName([LINE, PRODUCT, 'SEO_TITLE']);
var LINE_PRODUCT_SERVICES = getGqlName([LINE, PRODUCT, 'SERVICES']);
var LINE_PRODUCT_SPACE_INTRODUCTION = getGqlName([LINE, PRODUCT, 'SPACE_INTRODUCTION']);
var LINE_PRODUCT_STREET_VIEW = getGqlName([LINE, PRODUCT, 'STREET_VIEW']);
var LINE_PRODUCT_STRENGTHS = getGqlName([LINE, PRODUCT, 'STRENGTHS']);
var LINE_PRODUCT_SUMMARY = getGqlName([LINE, PRODUCT, 'SUMMARY']);
var LINE_PRODUCT_TRIPADVISOR = getGqlName([LINE, PRODUCT, 'TRIPADVISOR']);
var LINE_PRODUCT_WELLNESS = getGqlName([LINE, PRODUCT, 'WELLNESS']);
var LINE_CRUISE_BOOKING = getGqlName([LINE, CRUISE, 'BOOKING']);
var LINE_CRUISE_PROGRAM = getGqlName([LINE, CRUISE, 'PROGRAM']);
var LINE_TOUR_INTRODUCTION = getGqlName([LINE, TOUR, 'INRODUCTION']);
var LINE_TOUR_PRACTICAL_INFO = getGqlName([LINE, TOUR, 'PRACTICAL_INFO']);
var LINE_TOUR_PROGRAM = getGqlName([LINE, TOUR, 'PROGRAM']); // REDUX REQUESTS

var STATE_PRODUCT_ALL_INCLUSIVE_SERVICES = getGqlName([STATE, PRODUCT, 'ALL_INCLUSIVE_SERVICES']);
var STATE_PRODUCT_BOOKABLE_DATES = getGqlName([STATE, PRODUCT, 'BOOKABLE_DATES']);
var STATE_PRODUCT_CALENDAR = getGqlName([STATE, PRODUCT, 'CALENDAR']);
var STATE_PRODUCT_PRICE_TICKET = getGqlName([STATE, PRODUCT, 'PRICE_TICKET']);
var STATE_PRODUCT_PRICE_OF_STAY = getGqlName([STATE, PRODUCT, 'PRICE_OF_STAY']);
var STATE_SEARCH_FACETING_TOP_COUNTRIES = getGqlName([STATE, SEARCH, 'FACETING_TOP_COUNTRIES']);
var STATE_SEARCH_OFFSET_SELL = getGqlName([STATE, SEARCH, 'OFFSET_SELL']);
var STATE_SEARCH_PRODUCT_CHILDCARE = getGqlName([STATE, SEARCH, 'PRODUCT_CHILDCARE']);
var STATE_SEARCH_PRODUCT_CONFIG = getGqlName([STATE, SEARCH, 'PRODUCT_CONFIG']);
var STATE_SEARCH_PRODUCTS = getGqlName([STATE, SEARCH, 'PRODUCTS']);
var STATE_SEARCH_PRODUCT_PRICE = getGqlName([STATE, SEARCH, 'PRODUCT_PRICE']); // WIDGET REQUESTS

var WIDGET_CRUISE_BOOKING_CALL_PRICE = getGqlName([WIDGET, 'CRUISE_BOOKING', 'CALL_PRICE']);
var WIDGET_EVENT_FORM_SUBMIT = getGqlName([WIDGET, 'EVENT_FORM', 'SUBMIT']);
var WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES = getGqlName([WIDGET, 'PRODUCT_ACTIVITIES', 'FETCH_SERVICES']);
var WIDGET_QUOTATION_FORM_SUBMIT = getGqlName([WIDGET, 'QUOTATION_FORM', 'SUBMIT']);
var WIDGET_QUOTATION_FORM_TRACK = getGqlName([WIDGET, 'QUOTATION_FORM', 'TRACK']);
var WIDGET_WEBCALLBACK_OPENING_HOURS = getGqlName([WIDGET, 'WEBCALLBACK', 'OPENING_HOURS']);
var WIDGET_WEBCALLBACK_SCHEDULE_CALL = getGqlName([WIDGET, 'WEBCALLBACK', 'SCHEDULE_CALL']); // CORE

var CORE_LAYOUT = getGqlName([CORE, 'LAYOUT']);
var CORE_GET_COMMON_I18N = getGqlName([CORE, 'I18N']);
var CORE_GET_FACEBOOK_CONNECT_CONFIG = getGqlName([CORE, 'GET_FACEBOOK_CONNECT_CONFIG']);
var PRODUCT_GET_PACKAGE_INFO = getGqlName([PRODUCT, 'GET_PACKAGE_INFO']);
var BOOKING_GET_BOOKING_I18N = getGqlName([DOMAINS.BOOKING, 'GET_BOOKING_I18N']); // CUSTOMER ACCOUNT

var CUSTOMER_ACCOUNT_GET_IMMERSIVE_PICTURES = getGqlName([CUSTOMER_ACCOUNT, 'GET_IMMERSIVE_PICTURES']);
var CUSTOMER_ACCOUNT_GET_FUTURE_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'FUTURE_TRIPS']);
var CUSTOMER_ACCOUNT_GET_PAST_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'PAST_TRIPS']);
var CUSTOMER_ACCOUNT_GET_PROFILE_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_PROFILE_DATA']);
var CUSTOMER_ACCOUNT_GET_PROFILE_NEWSLETTER_CONFIG = getGqlName([CUSTOMER_ACCOUNT, 'GET_PROFILE_NEWSLETTER_CONFIG']);
var CUSTOMER_ACCOUNT_GET_SEARCHES = getGqlName([CUSTOMER_ACCOUNT, 'GET_SEARCHES']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_ACTIVITIES_SECTION = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_ACTIVITIES_SECTION']);
var CUSTOMER_ACCOUNT_GET_DATA_ACTIVITIES_SECTION = getGqlName([CUSTOMER_ACCOUNT, 'GET_DATA_ACTIVITIES_SECTION']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_GREAT_MEMBER = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_GREAT_MEMBER']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_BOOKING_VIEW = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_BOOKING_VIEW']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_PREPAYMENT = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_PREPAYMENT']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_PREPAREMYSTAY = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_PREPAREMYSTAY']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_FUTURE_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_FUTURE_TRIPS']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_PAST_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_PAST_TRIPS']);
var CUSTOMER_ACCOUNT_GET_CMS_DATA_USER_SEARCHES = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_DATA_USER_SEARCHES']);
var CUSTOMER_ACCOUNT_SPONSORSHIP_VIEW_RESOLVER = getGqlName([CUSTOMER_ACCOUNT, 'SPONSORSHIP_VIEW_RESOLVER']);
var CUSTOMER_ACCOUNT_GET_SPONSORSHIP_PROGRAM = getGqlName([CUSTOMER_ACCOUNT, 'GET_SPONSORSHIP_PROGRAM']);
var CUSTOMER_ACCOUNT_GET_TRAVEL_COMPANIONS = getGqlName([CUSTOMER_ACCOUNT, 'GET_TRAVEL_COMPANIONS']);
var CUSTOMER_ACCOUNT_GM_GET_POINTS = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_POINTS']);
var CUSTOMER_ACCOUNT_GM_GET_USER_LOYALTY = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_USER_LOYALTY']);
var CUSTOMER_ACCOUNT_GET_CMS_CONTENT_TRANSFER = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_CMS_CONTENT_TRANSFER']);
var CUSTOMER_ACCOUNT_GET_TRANSFERS = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_TRANSFERS']);
var CUSTOMER_ACCOUNT_GET_TRANSFER_DETAILS = getGqlName([CUSTOMER_ACCOUNT, 'GM_GET_TRANSFER_DETAILS']);
var CUSTOMER_ACCOUNT_SUBMIT_FORM_SPONSOR_A_FRIEND = getGqlName([CUSTOMER_ACCOUNT, 'SUBMIT_FORM_SPONSOR_A_FRIEND']);
var CUSTOMER_ACCOUNT_UPDATE_PASSPORT = getGqlName([CUSTOMER_ACCOUNT, 'UPDATE_PASSPORT']);
var CUSTOMER_ACCOUNT_UPDATE_PASSWORD = getGqlName([CUSTOMER_ACCOUNT, 'UPDATE_PASSWORD']);
var CUSTOMER_ACCOUNT_UPDATE_PERSONAL_INFO = getGqlName([CUSTOMER_ACCOUNT, 'UPDATE_PERSONAL_INFO']);
var CUSTOMER_ACCOUNT_GET_FURTHER_INFORMATION = getGqlName([CUSTOMER_ACCOUNT, 'GET_FURTHER_INFORMATION']);
var CUSTOMER_ACCOUNT_VIEW_RESOLVER = getGqlName([CUSTOMER_ACCOUNT, 'VIEW_RESOLVER']);
var CUSTOMER_ACCOUNT_PROFILE_VIEW_RESOLVER = getGqlName([CUSTOMER_ACCOUNT, 'PROFILE_VIEW_RESOLVER']);
var CUSTOMER_ACCOUNT_DASHBOARD_RESOLVER = getGqlName([CUSTOMER_ACCOUNT, 'DASHBOARD_RESOLVER']);
var CUSTOMER_ACCOUNT_SEARCHES_RESOLVER = getGqlName([CUSTOMER_ACCOUNT, 'SEARCHES_RESOLVER']);
var CUSTOMER_ACCOUNT_GET_CMS_CONTENT_DASHBOARD = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_CONTENT_DASHBOARD']);
var CUSTOMER_ACCOUNT_GET_CMS_CONTENT_QUICK_DASHBOARD = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_CONTENT_QUICK_DASHBOARD']);
var CUSTOMER_ACCOUNT_GET_CMS_CONTENT = getGqlName([CUSTOMER_ACCOUNT, 'GET_CMS_CONTENT']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_CUSTOMER = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_CUSTOMER']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_FUTURE_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_FUTURE_TRIPS']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_CURRENT_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_CURRENT_TRIPS']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_PAST_TRIPS = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_PAST_TRIPS']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_SEARCHES = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_SEARCHES']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_SPONSORSHIP = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_SPONSORSHIP']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_PROFILE = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_PROFILE']);
var CUSTOMER_ACCOUNT_GET_DASHBOARD_SUMMARY = getGqlName([CUSTOMER_ACCOUNT, 'GET_DASHBOARD_SUMMARY']);
var CUSTOMER_ACCOUNT_GET_QUICK_DASHBOARD_CUSTOMER = getGqlName([CUSTOMER_ACCOUNT, 'GET_QUICK_DASHBOARD_CUSTOMER']);
var CUSTOMER_ACCOUNT_GET_VOUCHERS = getGqlName([CUSTOMER_ACCOUNT, 'GET_VOUCHERS']);
var CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS = getGqlName([CUSTOMER_ACCOUNT, 'GET_LOYALTY_DETAILS']);
var CUSTOMER_ACCOUNT_GET_VOUCHERS_CMS_CONTENT = getGqlName([CUSTOMER_ACCOUNT, 'VOUCHERS_GET_CMS_CONTENT']);
var CUSTOMER_ACCOUNT_GET_BOOKING_DATA = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKING_DATA']);
var CUSTOMER_ACCOUNT_GET_BOOKING_CHILDCARE = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKING_CHILDCARE']);
var CUSTOMER_ACCOUNT_GET_BOOKING_CART = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKING_CART']);
var CUSTOMER_ACCOUNT_GET_BOOKING_RENTALS = getGqlName([CUSTOMER_ACCOUNT, 'GET_BOOKING_RENTALS']);
var CUSTOMER_ACCOUNT_GET_AVAILABLE_RENTALS = getGqlName([CUSTOMER_ACCOUNT, 'GET_AVAILABLE_RENTALS']);
var CUSTOMER_ACCOUNT_GET_RENTALS_CMS_CONTENT = getGqlName([CUSTOMER_ACCOUNT, 'GET_RENTALS_CMS_CONTENT']);
var CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART = getGqlName([CUSTOMER_ACCOUNT, 'UPDATE_BOOKING_CART']);
var CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM = getGqlName([CUSTOMER_ACCOUNT, 'REMOVE_BOOKING_CART_ITEM']); // CUSTOMER BOOKING

var CUSTOMER_BOOKING_AUTHORIZATION_NOTIFY = getGqlName([CUSTOMER_BOOKING, 'AUTHORIZATION_NOTIFY']);
var CUSTOMER_BOOKING_AUTHORIZATION_REDIRECT = getGqlName([CUSTOMER_BOOKING, 'AUTHORIZATION_REDIRECT']);
var CUSTOMER_BOOKING_GET_ACTIVITIES = getGqlName([CUSTOMER_BOOKING, 'GET_ACTIVITIES']);
var CUSTOMER_BOOKING_GET_ATTENDEES = getGqlName([CUSTOMER_BOOKING, 'GET_ATTENDEES']);
var CUSTOMER_BOOKING_GET_STAY_FORMALITIES = getGqlName([CUSTOMER_BOOKING, 'GET_STAY_FORMALITIES']);
var CUSTOMER_BOOKING_GET_AVAILABLE_RENTAL_EQUIPMENTS = getGqlName([CUSTOMER_BOOKING, 'GET_AVAILABLE_RENTAL_EQUIPMENTS']);
var CUSTOMER_FIDELITY_STATUS = getGqlName([CUSTOMER_BOOKING, 'GET_FIDELITY_STATUS']);
var CUSTOMER_BOOKING_GET_CUSTOMERS = getGqlName([CUSTOMER_BOOKING, 'GET_CUSTOMERS']);
var CUSTOMER_BOOKING_GET_DASHBOARD_DATA = getGqlName([CUSTOMER_BOOKING, 'GET_DASHBOARD_DATA']);
var CUSTOMER_BOOKING_GET_DATA = getGqlName([CUSTOMER_BOOKING, 'GET_DATA']);
var CUSTOMER_BOOKING_GET_DOCUMENTS = getGqlName([CUSTOMER_BOOKING, 'GET_BOOKING_DOCUMENTS']);
var CUSTOMER_BOOKING_GET_PRICE_AND_PAYMENT_DATA = getGqlName([CUSTOMER_BOOKING, 'GET_BOOKING_PRICE_AND_PAYMENT_DATA']);
var CUSTOMER_BOOKING_GET_TRANSPORT_DATA = getGqlName([CUSTOMER_BOOKING, 'GET_TRANSPORT_DATA']);
var CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA = getGqlName([CUSTOMER_BOOKING, 'PREBOOKING_FETCH_DATA']);
var CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS = getGqlName([CUSTOMER_BOOKING, 'PREBOOKING_FETCH_RESORTS']);
var CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS = getGqlName([CUSTOMER_BOOKING, 'PREBOOKING_FETCH_TRAVELERS']);
var CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT = getGqlName([CUSTOMER_BOOKING, 'PREBOOKING_FORM_SUBMIT']);
var CUSTOMER_BOOKING_PREPARE_MY_STAY = getGqlName([CUSTOMER_BOOKING, 'PREPARE_MY_STAY']);
var CUSTOMER_BOOKING_PREPARE_MY_STAY_GET_STAY_FORMALITIES = getGqlName([CUSTOMER_BOOKING, 'PREPARE_MY_STAY_GET_STAY_FORMALITIES']);
var CUSTOMER_BOOKING_PYR_ROOM_ONLY_REQUEST = getGqlName([CUSTOMER_BOOKING, 'CUSTOMER_BOOKING_PYR_ROOM_ONLY']);
var CUSTOMER_BOOKING_PYR_GET_GEO_DATA = getGqlName([CUSTOMER_BOOKING, 'PYR_GET_GEO_DATA']);
var CUSTOMER_BOOKING_PYR_AGENCY_FORM = getGqlName([CUSTOMER_BOOKING, 'PYR_AGENCY_FORM']);
var CUSTOMER_BOOKING_PYR_GET_RESORT_SETTINGS = getGqlName([CUSTOMER_BOOKING, 'PYR_GET_RESORT_SETTINGS']);
var CUSTOMER_BOOKING_PYR_GET_RESORTS = getGqlName([CUSTOMER_BOOKING, 'PYR_GET_RESORTs']);
var CUSTOMER_BOOKING_PYR_GET_ROOM_SELECTION = getGqlName([CUSTOMER_BOOKING, 'PYR_GET_ROOM_SELECTION']);
var CUSTOMER_BOOKING_PYR_GET_ROOM_SELECTION_AGENCY = getGqlName([CUSTOMER_BOOKING, 'PYR_GET_ROOM_SELECTION_AGENCY']);
var CUSTOMER_BOOKING_PYR_PAYMENT_BUTTON = getGqlName([CUSTOMER_BOOKING, 'PYR_PAYMENT_BUTTON']);
var CUSTOMER_BOOKING_PYR_PUSH_INFO = getGqlName([CUSTOMER_BOOKING, 'PYR_PUSH_INFO']);
var CUSTOMER_BOOKING_PYR_MAP_ROOMS = getGqlName([CUSTOMER_BOOKING, 'PYR_MAP_ROOMS']);
var CUSTOMER_BOOKING_PYR_MAP_CMS = getGqlName([CUSTOMER_BOOKING, 'PYR_MAP_CMS']);
var CUSTOMER_BOOKING_PYR_AGENCY_VIEW_RESOLVER = getGqlName([CUSTOMER_BOOKING, 'PYR_AGENCY_VIEW_RESOLVER']);
var CUSTOMER_BOOKING_PYR_RESORT_FORM_CMS = getGqlName([CUSTOMER_BOOKING, 'PYR_RESORT_FORM_CMS']);
var CUSTOMER_BOOKING_PYR_RESORT_CATEGORIES = getGqlName([CUSTOMER_BOOKING, 'PYR_RESORT_FORM_CATEGORIES']);
var CUSTOMER_BOOKING_UPDATE_CHECKOUT = getGqlName([CUSTOMER_BOOKING, 'UPDATE_CHECKOUT']);
var CUSTOMER_BOOKING_UPDATE_TRANSFER = getGqlName([CUSTOMER_BOOKING, 'UPDATE_TRANSFER']);
var CUSTOMER_BOOKING_OPTION_CONFIRMATION_VIEW_RESOLVER = getGqlName([CUSTOMER_BOOKING, 'OPTION_CONFIRMATION_VIEW_RESOLVER']);
var CUSTOMER_BY_HOME = getGqlName([CUSTOMER_BOOKING, 'CUSTOMER_BY_HOME']);
var CRITERIA_OFFSETSELL = getGqlName([CUSTOMER_BOOKING, 'CRITERIA_OFFSETSELL']); // NEWSLETTER

var NEWSLETTER_GET_SUBSCRIPTIONS = getGqlName([NEWSLETTER, 'GET_SUBSCRIPTIONS']);
var NEWSLETTER_SUBMIT_SUBSCRIPTION = getGqlName([NEWSLETTER, 'SUBMIT_SUBSCRIPTION']);
var NEWSLETTER_SUBMIT_SUBSCRIPTION_QUOTATION_FORM = getGqlName([NEWSLETTER, 'SUBMIT_SUBSCRIPTION_QUOTATION_FORM']);
var NEWSLETTER_SUBSCRIPTION_VIEW_RESOLVER = getGqlName([NEWSLETTER, 'SUBSCRIPTION_VIEW_RESOLVER']);
var NEWSLETTER_CONFIRM_SUBSCRIPTION_VIEW_RESOLVER = getGqlName([NEWSLETTER, 'CONFIRM_SUBSCRIPTION_VIEW_RESOLVER']);
var NEWSLETTER_SUBMIT_QUOTATION_FORM = getGqlName([NEWSLETTER, 'SUBMIT_QUOTATION_FORM']); // PAYMENT

var PAYMENT_APPROVE = getGqlName([PAYMENT, 'APPROVE']);
var PAYMENT_CONFIRMATION_GET_BOOKING_DATA = getGqlName([PAYMENT, 'CONFIRMATION_GET_BOOKING_DATA']);
var PAYMENT_CONFIRMATION_GET_TRACKING_DATA = getGqlName([PAYMENT, 'CONFIRMATION_GET_TRACKING_DATA']);
var PAYMENT_GET_STATUS = getGqlName([PAYMENT, 'GET_STATUS']);
var PAYMENT_INFO = getGqlName([PAYMENT, 'INFO']);
var PAYMENT_INIT = getGqlName([PAYMENT, 'INIT']);
var PAYMENT_NOTIFY_MUTATION = getGqlName([PAYMENT, 'NOTIFY_MUTATION']);
var PAYMENT_STATUS_MUTATION = getGqlName([PAYMENT, 'STATUS_MUTATION']);
var PAYMENT_POLLING_GET_STATUS = getGqlName([PAYMENT, 'POLLING_GET_STATUS']);
var PAYMENT_PRE_GET_DETAILS = getGqlName([PAYMENT, 'PRE_GET_DETAILS']);
var PAYMENT_PRE_GET_FORM_DATA = getGqlName([PAYMENT, 'PRE_GET_FORM_DATA']);
var PAYMENT_REDIRECT = getGqlName([PAYMENT, 'REDIRECT']);
var PAYMENT_STATUS = getGqlName([PAYMENT, 'STATUS']);
var PAYMENT_CLEAN_CART = getGqlName([PAYMENT, 'CLEAN_CART']);
var PAYMENT_CONFIRMATION_VIEW_RESOLVER = getGqlName([PAYMENT, 'CONFIRMATION_VIEW_RESOLVER']);
var PAYMENT_NOTIFICATION_VIEW_RESOLVER = getGqlName([PAYMENT, 'NOTIFICATION_VIEW_RESOLVER']); // PROPOSAL

var PROPOSAL_ACCOMMODATION_ADD = getGqlName([PROPOSAL, 'ACCOMMODATION_ADD']);
var PROPOSAL_ADD_TRANSPORT = getGqlName([PROPOSAL, 'ADD_TRANSPORT']);
var PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS = getGqlName([PROPOSAL, 'GET_ADDITIONAL_ACCOMMODATIONS']);
var PROPOSAL_GET_ADDITIONAL_TRANSPORT = getGqlName([PROPOSAL, 'GET_ADDITIONAL_TRANSPORT']);
var PROPOSAL_ADD_RENTAL_EQUIPMENT = getGqlName([PROPOSAL, 'ADD_RENTAL_EQUIPMENT']);
var PROPOSAL_REMOVE_RENTAL_EQUIPMENT = getGqlName([PROPOSAL, 'REMOVE_RENTAL_EQUIPMENT']);
var PROPOSAL_GET_AVAILABLE_RENTAL_EQUIPMENTS = getGqlName([PROPOSAL, 'GET_AVAILABLE_RENTAL_EQUIPMENTS']);
var PROPOSAL_GET_BY_ID = getGqlName([PROPOSAL, 'GET_BY_ID']);
var PROPOSAL_GET_ONE = getGqlName([PROPOSAL, 'GET_ONE']);
var PROPOSAL_GET_SEVERAL = getGqlName([PROPOSAL, 'GET_SEVERAL']);
var PROPOSAL_LINE_BOOKING_SUMMARY = getGqlName([PROPOSAL, 'LINE_BOOKING_SUMMARY']);
var PROPOSAL_LINE_CONFIRMATION = getGqlName([PROPOSAL, 'LINE_CONFIRMATION']);
var PROPOSAL_LINE_PAYMENT_INFO = getGqlName([PROPOSAL, 'LINE_PAYMENT_INFO']);
var PROPOSAL_LINE_PAYMENT_INFO_TRACKING = getGqlName([PROPOSAL, 'LINE_PAYMENT_INFO_TRACKING']);
var PROPOSAL_LINE_PRICE_HEADER = getGqlName([PROPOSAL, 'LINE_PRICE_HEADER']);
var PROPOSAL_SAVE = getGqlName([PROPOSAL, 'SAVE']);
var PROPOSAL_UPDATE = getGqlName([PROPOSAL, 'UPDATE']);
var PROPOSAL_UPDATE_TRANSFER = getGqlName([PROPOSAL, 'UPDATE_TRANSFER']);
var PROPOSAL_USE_PROMO_CODE = getGqlName([PROPOSAL, 'USE_PROMO_CODE']);
var PROPOSAL_GET_SCHEDULE_PAYMENT = getGqlName([PROPOSAL, 'GET_SCHEDULE_PAYMENT']);
var PROPOSAL_UPDATE_ATTENDEES = getGqlName([PROPOSAL, 'UPDATE_ATTENDEES']);
var PROPOSAL_UPDATE_INSURANCES = getGqlName([PROPOSAL, 'UPDATE_INSURANCES']);
var PROPOSAL_DELETE_INSURANCES = getGqlName([PROPOSAL, 'DELETE_INSURANCES']);
var PROPOSAL_SWITCH_OFFER = getGqlName([PROPOSAL, 'SWITCH_OFFER']);
var PROPOSAL_ADDITIONAL_SERVICES_ADD = getGqlName([PROPOSAL, 'PROPOSAL_ADDITIONAL_SERVICES_ADD']);
var PROPOSAL_ADDITIONAL_SERVICES_UPDATE = getGqlName([PROPOSAL, 'PROPOSAL_ADDITIONAL_SERVICES_UPDATE']);
var PROPOSAL_ADDITIONAL_SERVICES_DELETE = getGqlName([PROPOSAL, 'PROPOSAL_ADDITIONAL_SERVICES_DELETE']);
var COMPARATOR_VIEW_RESOLVER = getGqlName([DOMAINS.COMPARATOR, 'COMPARATOR_VIEW_RESOLVER']);
var SELLER_PREBOOKING_FORM_SUCCESS = getGqlName([DOMAINS.SELLER, 'SELLER_PREBOOKING_FORM_SUCCESS']);
var STREET_VIEW_GET_SEVERAL = getGqlName([STREET_VIEW, 'GET_SEVERAL']);

/***/ }),

/***/ "Cf/K":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"), __webpack_require__("77dk"), __webpack_require__("ZxLh"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),

/***/ "E7j9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "ESA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getQueryResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setQueryResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearAllCacheFront; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9NGo");



var cacheFrontPrefix = 'CACHE_FRONT__';
function getQueryResult(cacheKey) {
  var customerNeolaneId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#';
  if (!cacheKey) return null;

  try {
    var _JSON$parse = JSON.parse(Object(_client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__[/* getFromSessionStorage */ "b"])(cacheFrontPrefix + cacheKey + customerNeolaneId) || '{}'),
        expirationDate = _JSON$parse.expirationDate,
        result = _JSON$parse.result;

    if (!expirationDate) return null;

    if (moment__WEBPACK_IMPORTED_MODULE_1___default()(expirationDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_1___default()())) {
      Object(_client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__[/* removeFromSessionStorage */ "c"])(cacheFrontPrefix + cacheKey + customerNeolaneId);
      return null;
    }

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}
function setQueryResult(_ref) {
  var cacheKey = _ref.cacheKey,
      _ref$cacheExpirationD = _ref.cacheExpirationDate,
      cacheExpirationDate = _ref$cacheExpirationD === void 0 ? moment__WEBPACK_IMPORTED_MODULE_1___default()().add('2', 'minutes') : _ref$cacheExpirationD,
      result = _ref.result,
      _ref$customerNeolaneI = _ref.customerNeolaneId,
      customerNeolaneId = _ref$customerNeolaneI === void 0 ? '#' : _ref$customerNeolaneI;

  try {
    Object(_client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__[/* setInSessionStorage */ "d"])(cacheFrontPrefix + cacheKey + customerNeolaneId, JSON.stringify({
      expirationDate: cacheExpirationDate,
      result: result
    }));
  } catch (e) {
    console.error(e);
  }

  return null;
}
function clearAllCacheFront() {
  Object(_client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__[/* getEntries */ "a"])().forEach(function (_ref2) {
    var _ref3 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref2, 1),
        key = _ref3[0];

    if (key.startsWith(cacheFrontPrefix)) {
      Object(_client_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_2__[/* removeFromSessionStorage */ "c"])(key);
    }
  });
}

/***/ }),

/***/ "F63i":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "FYay":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "GRjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDOMAspect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLandscape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isRTL; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("I6kL");





function getDOMAspect(isAppMounted) {
  var domCharacteristics = {
    viewportWidthPX: 0,
    viewportHeightPX: 0,
    htmlFontSize: 0
  };

  if (isAppMounted) {
    domCharacteristics = {
      viewportWidthPX: _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].getClientWidth(),
      viewportHeightPX: _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].getClientHeight(),
      htmlFontSize: parseInt(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].getFontSize(), 10)
    };
  }

  return domCharacteristics;
}

function getCurrentBreakpoint() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isAppMounted = arguments.length > 1 ? arguments[1] : undefined;

  if (!isAppMounted) {
    if (_config__WEBPACK_IMPORTED_MODULE_2___default.a.get('featureFlipping.ssr.mobile-first') || !userAgent || /(mobile|tablet|iPhone|iPad|Android)/i.test(userAgent)) {
      return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XXS;
    }

    return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XL;
  }

  return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_3__[/* MEDIA_QUERIES */ "c"].reduce(function (previousValue, currentValue) {
    return _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].matchMediaQuery(currentValue.mediaquery) ? currentValue : previousValue;
  }).breakpoint;
}

function isLandscape(isAppMounted) {
  return isAppMounted ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].matchMediaQuery('all and (orientation:landscape)') : false;
}

function isRTL(isAppMounted) {
  return isAppMounted ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].getDocumentElement().dir === 'rtl' : false;
}



/***/ }),

/***/ "H6pA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCESS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_INFO; });
/* unused harmony export SELLER_ACCESS_TOKEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELLER_LOGGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELLER_INFO; });
// TODO: duplicated on graphql/src/authentication/helpers/cookies.js... move to @clubmed/utils
var ACCESS_TOKEN = 'CM_TOKEN';
var USER_INFO = 'cm_userinfo';
var SELLER_ACCESS_TOKEN = 'CM_SELLER_TOKEN';
var SELLER_LOGGED = 'SELLER_LOGGED';
var SELLER_INFO = 'cm_seller_info';

/***/ }),

/***/ "HO86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _unsupportedIterableToArray; });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("lEbO");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(o, minLen);
}

/***/ }),

/***/ "I6kL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BREAKPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDERED_BREAKPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_CELL_COLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEDIA_QUERIES; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");

var BREAKPOINTS = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL'
};
var ORDERED_BREAKPOINTS = [BREAKPOINTS.XXS, BREAKPOINTS.XS, BREAKPOINTS.S, BREAKPOINTS.M, BREAKPOINTS.L, BREAKPOINTS.XL];
var MEDIA_QUERIES = [{
  breakpoint: BREAKPOINTS.XXS,
  mediaquery: '(min-width: 0)'
}, {
  breakpoint: BREAKPOINTS.XS,
  mediaquery: '(min-width: 22.51em)'
}, {
  breakpoint: BREAKPOINTS.S,
  mediaquery: '(min-width: 40.01em)'
}, {
  breakpoint: BREAKPOINTS.M,
  mediaquery: '(min-width: 50.01em)'
}, {
  breakpoint: BREAKPOINTS.L,
  mediaquery: '(min-width: 64.01em)'
}, {
  breakpoint: BREAKPOINTS.XL,
  mediaquery: '(min-width: 76.26em)'
}];

var DEFAULT_CELL_COLS = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, BREAKPOINTS.XXS, 12);



/***/ }),

/***/ "IGGJ":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "IOAS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "J1qw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("FYay");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "KEM+":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "KL6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getOpportunityGUID; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getCxoTravelers; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getNeolids; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ isSeller; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ redirectNewTabToNA; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ sendFacetsToCxO; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ saveCustomerProposal; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getSigninURIWithRedirection; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ saveCustomerProposalAndSendContextToCxO; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ sellerUtils_handle401GraphqlErrorSeller; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ sellerUtils_decryptHeptaSeller; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ isSellerAndInMultiplesFamiliesContext; });

// UNUSED EXPORTS: getCurrentQueryParamsAndState

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__("O2W8");
var lz_string_default = /*#__PURE__*/__webpack_require__.n(lz_string);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/crypto-js/aes.js
var aes = __webpack_require__("4a5f");
var aes_default = /*#__PURE__*/__webpack_require__.n(aes);

// EXTERNAL MODULE: /opt/webapp/node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__("tZkf");
var enc_utf8_default = /*#__PURE__*/__webpack_require__.n(enc_utf8);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/utils/seller/constants.js
var CXO_CONTEXT_FUNC_TO_CALL = 'Call-GenerateWebNAURL-Function';
var CXO_FACETS_FUNC_TO_CALL = 'RMC-Function';
var CXO_DATE_FORMAT = 'YYYY-MM-DD';
var MISSING_ARGUMENTS_TO_SAVE_CUSTOMER_PROPOSAL = 'Missing arguments to make call for ressource saveCustomerProposals';

// CONCATENATED MODULE: ./src/utils/seller/sellerUtils.js





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */

















var CXO_CRYPTO_PASSWORD = 'clubmed-cxo';

function cxoDateToTimestamp(cxoDate) {
  return cxoDate ? moment_default()(cxoDate, CXO_DATE_FORMAT).valueOf() : undefined;
}

function _getQueryParametersFromCurrentUri() {
  var location = dist["windowWrapper"].getLocation();
  return location ? URI_default.a.parseQuery(new URI_default.a(location).query()) : null;
}

function _getQueryParametersAndValuesFromCurrentUri() {
  var location = dist["windowWrapper"].getLocation();
  return location ? new URI_default.a(location).search() : null;
}

function _getCxoUrl() {
  return URI_default.a.decode(Object(lodash["get"])(_getQueryParametersFromCurrentUri(), dist["appQueryParameters"].cxo.cxo_url));
}

function _performPostMessage(functionToCall, params) {
  var parent = dist["windowWrapper"].get('opener') || dist["windowWrapper"].get('parent');

  if (parent) {
    var origin = _getCxoUrl();

    return new Promise(function (resolve, reject) {
      try {
        parent.postMessage([functionToCall].concat(Object(toConsumableArray["a" /* default */])(params)), origin);
        resolve();
      } catch (e) {
        reject();
      }
    });
  }
}

function _getQueryParam(queryParam) {
  return Object(lodash["get"])(_getQueryParametersFromCurrentUri(), queryParam);
}
/**
 * @deprecated
 * @param {*} appContext
 * @returns
 */


function isSeller(appContext) {
  return !!(appContext.isDirectCxo || appContext.isIndirectCxo || appContext.isCmta);
}

function getOpportunityGUID(queryParams) {
  // $FlowFixMe some queryParams are arrays
  return queryParams[dist["appQueryParameters"].cxo.cxo_opportunity_guid];
}

function _parseCxoTraveler(cxoTraveler, primaryContactNeolid) {
  // cxo_traveler can be an adult with syntax: 'neolid' or a child: 'neolid,birthdate'
  var travelerInfo = cxoTraveler.split(',');
  return {
    neolid: travelerInfo[0],
    isMainContact: travelerInfo[0] === primaryContactNeolid,
    isChild: !!travelerInfo[1],
    birthdate: cxoDateToTimestamp(travelerInfo[1])
  };
}

function getCxoTravelers() {
  var cxoTravelers = _getQueryParam(dist["appQueryParameters"].cxo.cxo_traveler);

  var primaryContactNeolid = _getQueryParam(dist["appQueryParameters"].cxo.cxo_primarycontact);

  if (!cxoTravelers) return null;
  var travelers = Object(lodash["castArray"])(cxoTravelers).map(function (traveler) {
    return _parseCxoTraveler(traveler, primaryContactNeolid);
  }); // If there is no main contact in the travelers it defaults to the first adult

  if (!travelers.some(function (traveler) {
    return traveler.isMainContact;
  })) {
    Object(lodash["set"])(travelers.find(function (traveler) {
      return !traveler.isChild;
    }), 'isMainContact', true);
  } // The main contact is put first in the array to avoid deletion on later participant change


  travelers.sort(function (a, b) {
    if (a.isMainContact) return -1;
    return b.isMainContact ? 1 : 0;
  });
  return travelers;
}

function getNeolids() {
  return (getCxoTravelers() || []).map(function (traveler) {
    return traveler.neolid;
  });
}

function saveCustomerProposal(proposalId, appContext, customerId) {
  if (!customerId) {
    return Promise.reject();
  }

  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      saveCustomerProposals(\n        customerId : \"".concat(customerId, "\",\n        proposalId: \"").concat(proposalId, "\") {\n          errorDescription (content:\"").concat(cmsContent || '', "\" release:\"").concat(cmsRelease || '', "\")\n          errorKey\n      }\n    }"), appContext, {
    requestName: requestDictionary["ud" /* PROPOSAL_SAVE */]
  });
}

var sellerUtils_getWebNaBaseURL = function getWebNaBaseURL() {
  return "".concat(config_default.a.get('na.url'), "/CxOInstant.jsp");
};

var getQueryStringNeolIds = function getQueryStringNeolIds(proposal) {
  return proposal.attendees.list.reduce(function (acc, _ref) {
    var customerId = _ref.customerId;
    return acc + '&cxo_neolid=' + (customerId || '');
  }, '');
};

function redirectNewTabToNA(_ref2) {
  var newTab = _ref2.newTab,
      step = _ref2.step,
      context = _ref2.context,
      opportunityId = _ref2.opportunityId,
      proposal = _ref2.proposal,
      location = _ref2.location;
  var actionCode = '';

  if (step === booking_constants["q" /* CXO_STEP */].CONFIGURE) {
    actionCode = '&action_code=P';
  }

  newTab.location.href = "".concat(sellerUtils_getWebNaBaseURL(), "?cxo_opportunity_guid=").concat(opportunityId || '', "&cxo_sales_network_id=").concat(location.queryParams.cxo_sales_network_id || '', "&cxo_step=").concat(step, "&cxo_context=").concat(context).concat(getQueryStringNeolIds(proposal), "&init_na=").concat(location.queryParams.init_na || '').concat(actionCode);
}

function sendFacetsToCxO(facets) {
  _performPostMessage(CXO_FACETS_FUNC_TO_CALL, facets);
}

function getCurrentQueryParamsAndState(proposalId, step) {
  var currentQueryParams = URI_default.a.parseQuery(_getQueryParametersAndValuesFromCurrentUri());

  if (proposalId && step) {
    var state = lz_string_default.a.compressToEncodedURIComponent(JSON.stringify({
      proposalId: proposalId,
      step: step
    }));
    return _objectSpread(_objectSpread({}, currentQueryParams), {}, {
      state: state
    });
  }

  return currentQueryParams;
}

function getSigninURIWithRedirection(_ref3) {
  var locale = _ref3.locale,
      proposalId = _ref3.proposalId,
      step = _ref3.step,
      isCmta = _ref3.isCmta;
  var redirectUri = new URI_default.a(dist["windowWrapper"].getLocation()).query(getCurrentQueryParamsAndState(proposalId, step)).toString();
  return ple_utils["e" /* buildSellerSigninUrl */]({
    redirectUri: redirectUri,
    locale: locale,
    isCmta: isCmta
  });
}

function createCxoProject(proposalId, appContext, location, hasCheckedOpt, salesmanID) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      bookings(\n        proposalId: \"".concat(proposalId, "\"\n        opportunityId: \"").concat(location.queryParams.cxo_opportunity_guid || '', "\"\n        bookingStatus: OPTION\n        sendingOptionInformation: ").concat(hasCheckedOpt.toString(), "\n        ").concat(salesmanID ? "salesmanID: \"".concat(salesmanID, "\"") : '', "\n      ) {\n        bookingId\n      }\n    }"), appContext, {
    requestName: requestDictionary["ud" /* PROPOSAL_SAVE */]
  });
}

function saveCustomerProposalAndSendContextToCxO(_x) {
  return _saveCustomerProposalAndSendContextToCxO.apply(this, arguments);
}

function _saveCustomerProposalAndSendContextToCxO() {
  _saveCustomerProposalAndSendContextToCxO = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref4) {
    var proposalId, step, appContext, proposal, location, salesmanID, hasCheckedOption, cxoOpportunityId, cxoProjectId, newTab, cxoProject, status, error_code;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            proposalId = _ref4.proposalId, step = _ref4.step, appContext = _ref4.appContext, proposal = _ref4.proposal, location = _ref4.location, salesmanID = _ref4.salesmanID;
            hasCheckedOption = step === booking_constants["q" /* CXO_STEP */].AFFICHAGE;
            cxoOpportunityId = getOpportunityGUID(location.queryParams);
            cxoProjectId = proposalId;

            if (step !== booking_constants["q" /* CXO_STEP */].AFFICHAGE) {
              // open a new tab now to not be blocked by web browser
              newTab = window.open();
            }

            _context.prev = 5;

            if (!(step === booking_constants["q" /* CXO_STEP */].AFFICHAGE || step === booking_constants["q" /* CXO_STEP */].PAYMENT)) {
              _context.next = 25;
              break;
            }

            _context.prev = 7;
            _context.next = 10;
            return createCxoProject(proposalId, appContext, location, hasCheckedOption, salesmanID);

          case 10:
            cxoProject = _context.sent;
            _context.next = 24;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](7);
            status = Object(lodash["get"])(_context.t0, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);
            error_code = Object(lodash["get"])(_context.t0, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');

            if (!(status === statusCode_constants["b" /* STATUS_CODE_400 */] && error_code === constants["i" /* WRONG_SALESMAN_ID */])) {
              _context.next = 23;
              break;
            }

            _context.next = 20;
            return createCxoProject(proposalId, appContext, location, hasCheckedOption);

          case 20:
            cxoProject = _context.sent;
            _context.next = 24;
            break;

          case 23:
            throw _context.t0;

          case 24:
            if (cxoProject) {
              cxoProjectId = cxoProject.bookings.bookingId;
            }

          case 25:
            _context.next = 27;
            return saveCustomerProposal(proposalId, appContext, Object(lodash["get"])(proposal.attendees.list, '[0].customerId'));

          case 27:
            if (step !== booking_constants["q" /* CXO_STEP */].AFFICHAGE && newTab) {
              redirectNewTabToNA({
                newTab: newTab,
                step: step,
                appContext: appContext,
                proposal: proposal,
                opportunityId: cxoOpportunityId,
                context: cxoProjectId,
                location: location
              });
            }

            return _context.abrupt("return", {
              bookingId: cxoProjectId
            });

          case 31:
            _context.prev = 31;
            _context.t1 = _context["catch"](5);

            if (newTab) {
              newTab.close();
            }

            if (ple_utils["l" /* hasAuthResponseError */](_context.t1)) {
              dist["windowWrapper"].setLocation(getSigninURIWithRedirection({
                locale: appContext.locale,
                proposalId: proposalId,
                step: step,
                isCmta: appContext.isCmta
              }));
            }

            throw _context.t1;

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 31], [7, 13]]);
  }));
  return _saveCustomerProposalAndSendContextToCxO.apply(this, arguments);
}

var sellerUtils_handle401GraphqlErrorSeller = function handle401GraphqlErrorSeller(errors, appContext) {
  if (Object(lodash["get"])(errors, 'errors.[0].statusCode') === 401) {
    window.location.href = getSigninURIWithRedirection({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
  }
};

var sellerUtils_decryptHeptaSeller = function decryptHeptaSeller(cxoId) {
  return aes_default.a.decrypt(cxoId.replace(/\s/g, '+'), CXO_CRYPTO_PASSWORD).toString(enc_utf8_default.a);
};

var isSellerAndInMultiplesFamiliesContext = function isSellerAndInMultiplesFamiliesContext(appContext, attendees) {
  return (appContext.isDirectCxo || appContext.isIndirectCxo) && attendees.some(function (_ref5) {
    var gmNumber = _ref5.gmNumber;
    return !!gmNumber && gmNumber !== attendees[0].gmNumber;
  });
};



/***/ }),

/***/ "L7OA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFeatureFlipped; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _seller_sellerUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KL6I");




function _getKey(locale) {
  return function () {
    for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
      paths[_key] = arguments[_key];
    }

    return !!paths.reduce(function (resolved, currentPath) {
      return typeof resolved !== 'boolean' ? _config__WEBPACK_IMPORTED_MODULE_1___default.a.get(currentPath, locale) : resolved;
    }, null);
  };
}

function getKeyInfo(key) {
  return {
    b2cKey: "featureFlipping.".concat(key),
    b2cLegacyMobileKey: "featureFlipping.mobile.".concat(key),
    b2cMobileKey: "featureFlipping.".concat(key, ".mobile"),
    b2cDesktopKey: "featureFlipping.".concat(key, ".desktop"),
    sellerKey: "featureFlipping.seller.".concat(key)
  };
}

function isFeatureFlipped(appContext) {
  var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (key) {
    var locale = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(appContext, 'locale');

    var getKey = _getKey(locale);

    var _getKeyInfo = getKeyInfo(key),
        b2cKey = _getKeyInfo.b2cKey,
        b2cDesktopKey = _getKeyInfo.b2cDesktopKey,
        b2cLegacyMobileKey = _getKeyInfo.b2cLegacyMobileKey,
        b2cMobileKey = _getKeyInfo.b2cMobileKey,
        sellerKey = _getKeyInfo.sellerKey;

    if (Object(_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_2__[/* isSeller */ "g"])(appContext)) {
      return getKey(sellerKey, b2cKey);
    }

    return isMobile ? getKey(b2cMobileKey, b2cLegacyMobileKey, b2cKey) : getKey(b2cDesktopKey, b2cKey);
  };
}

/***/ }),

/***/ "L9Lm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var featureTesting = {
  getTestResult: function getTestResult(modernizrFeatureName) {
    if ( true && typeof window.Modernizr !== 'undefined') {
      return window.Modernizr[modernizrFeatureName];
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (featureTesting);

/***/ }),

/***/ "LdEA":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "M44J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "NByd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function assign(target, obj) {
  target = target || {};
  for (var prop in obj) {
    target[prop] = obj[prop];
  }
  return target;
};


/***/ }),

/***/ "Ni7E":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ "O3AJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "P0jV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("vfGT");
var isBuffer = __webpack_require__("lfu7");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "PIvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COMMON_CMS_CONTENT */
/* unused harmony export B2C_USER_AGENT */
/* unused harmony export TIMESTAMP_QUERY_PARAM */
/* unused harmony export GraphQLRequestFailed */
/* unused harmony export PAGES_CMS_CONTENT */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O2W8");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var error_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("x5Ag");
/* harmony import */ var error_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(error_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ggb3");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("L7OA");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ple_utils_cookies__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("H6pA");
/* harmony import */ var _cacheFront__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ESA2");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












 // This is the key matching the content containing the translations in the CMS

var COMMON_CMS_CONTENT = 'common';
var B2C_USER_AGENT = 'cm-b2c';
var TIMESTAMP_QUERY_PARAM = 't';
var GraphQLRequestFailed = error_js__WEBPACK_IMPORTED_MODULE_3___default.a.create({
  name: 'GraphQLRequestFailed',
  message: 'The GraphQL request failed'
});
var PAGES_CMS_CONTENT = 'pages';

function cleanGQLQuery(query) {
  return query.replace(/\s\s+/g, ' ');
}

function encodeGQLQuery(query) {
  return _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('graphql.compressedRequests') ? lz_string__WEBPACK_IMPORTED_MODULE_1___default.a.compressToEncodedURIComponent(query) : query;
}

function onResponse(_ref) {
  var data = _ref.data.data;
  return data;
}

function onRequestError(query) {
  return function (error) {
    var gqlError = new GraphQLRequestFailed({
      message: error.message,
      errors: Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(error, 'response.data.errors') || [],
      query: query
    });
    _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error(gqlError);
    return Promise.reject(gqlError);
  };
}

function getAxiosInstance(_ref2) {
  var gqlQuery = _ref2.gqlQuery;
  var axiosInstance = axios__WEBPACK_IMPORTED_MODULE_5___default.a.create();
  axiosInstance.interceptors.response.use(onResponse, onRequestError(gqlQuery));
  return axiosInstance;
}

function getHeaders(_ref3) {
  var _objectSpread2;

  var requestId = _ref3.requestId,
      origin = _ref3.origin,
      requestName = _ref3.requestName,
      isDirectCxo = _ref3.isDirectCxo,
      isIndirectCxo = _ref3.isIndirectCxo,
      isCmta = _ref3.isCmta,
      cacheable = _ref3.cacheable,
      bypassCache = _ref3.bypassCache,
      authenticationToken = _ref3.authenticationToken,
      customerNeolaneId = _ref3.customerNeolaneId,
      strictErrors = _ref3.strictErrors;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_4__["pickBy"])(_objectSpread(_objectSpread(_objectSpread((_objectSpread2 = {
    isDirectCxo: isDirectCxo,
    isIndirectCxo: isIndirectCxo,
    isCmta: isCmta,
    cookie:  false ? undefined : null,
    'user-agent': false ? undefined : undefined
  }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].X_REFERER, origin), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].X_REQUEST_NAME, requestName), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].X_PARENT_ID, requestId), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].X_GRAPH_ID, requestId), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].CM_STRICT_ERRORS, strictErrors), _objectSpread2), bypassCache === true ? Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].X_BYPASS_CACHE, true) : null), !cacheable ? {
    'cache-control': _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["httpHeaders"].NO_CACHE
  } : null), {}, {
    customerNeolaneId: customerNeolaneId
  }), lodash__WEBPACK_IMPORTED_MODULE_4__["identity"]);
}

function encodePrebuiltArgs(args) {
  var stringArgs = JSON.stringify(args);
  return _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('graphql.compressedRequests') ? lz_string__WEBPACK_IMPORTED_MODULE_1___default.a.compressToEncodedURIComponent(stringArgs) : stringArgs;
}

function getGraphqlEndpoint(_ref5) {
  var _URI$query;

  var locale = _ref5.locale,
      pagesContent = _ref5.pagesContent,
      pagesRelease = _ref5.pagesRelease,
      cmsContent = _ref5.cmsContent,
      cmsRelease = _ref5.cmsRelease,
      cacheable = _ref5.cacheable,
      gqlQuery = _ref5.gqlQuery,
      queryId = _ref5.queryId,
      prebuiltArgs = _ref5.prebuiltArgs;
  return new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('graphql.host')).query((_URI$query = {
    query: cacheable && !queryId ? encodeGQLQuery(cleanGQLQuery(gqlQuery)) : undefined,
    queryId: queryId ? queryId : undefined,
    prebuiltArgs: prebuiltArgs ? encodePrebuiltArgs(prebuiltArgs) : undefined,
    locale: locale,
    cmsConfig: JSON.stringify([{
      type: COMMON_CMS_CONTENT,
      release: cmsRelease,
      content: cmsContent
    }, {
      type: PAGES_CMS_CONTENT,
      release: pagesRelease,
      content: pagesContent
    }])
  }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_URI$query, TIMESTAMP_QUERY_PARAM, !cacheable ? moment__WEBPACK_IMPORTED_MODULE_6___default()().format('x') : undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_URI$query, "version", _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('APP_VERSION')), _URI$query)).toString();
}

function runQuery(gqlQuery) {
  var appContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    requestName: '',
    queryId: '',
    prebuiltArgs: {},
    cacheFront: {},
    strictErrors: true
  },
      _ref6$requestName = _ref6.requestName,
      requestName = _ref6$requestName === void 0 ? '' : _ref6$requestName,
      _ref6$queryId = _ref6.queryId,
      queryId = _ref6$queryId === void 0 ? '' : _ref6$queryId,
      _ref6$prebuiltArgs = _ref6.prebuiltArgs,
      prebuiltArgs = _ref6$prebuiltArgs === void 0 ? {} : _ref6$prebuiltArgs,
      _ref6$cacheFront = _ref6.cacheFront;

  _ref6$cacheFront = _ref6$cacheFront === void 0 ? {} : _ref6$cacheFront;
  var cacheKey = _ref6$cacheFront.key,
      cacheExpirationDate = _ref6$cacheFront.expirationDate,
      _ref6$strictErrors = _ref6.strictErrors,
      strictErrors = _ref6$strictErrors === void 0 ? true : _ref6$strictErrors;
  var cacheable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var locale = appContext.locale,
      cmsRelease = appContext.cmsRelease,
      cmsContent = appContext.cmsContent,
      pagesContent = appContext.pagesContent,
      pagesRelease = appContext.pagesRelease,
      authenticationToken = appContext.authenticationToken,
      isDirectCxo = appContext.isDirectCxo,
      isIndirectCxo = appContext.isIndirectCxo,
      originalUrl = appContext.originalUrl,
      requestId = appContext.requestId,
      isCmta = appContext.isCmta,
      customerNeolaneId = appContext.customerNeolaneId,
      _appContext$bypassCac = appContext.bypassCache,
      bypassCache = _appContext$bypassCac === void 0 ? false : _appContext$bypassCac;
  var cacheFrontEnabled = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_7__[/* isFeatureFlipped */ "a"])(appContext)('cacheFrontEnabled');
  var frontCachedResult = Object(_cacheFront__WEBPACK_IMPORTED_MODULE_12__[/* getQueryResult */ "b"])(cacheKey, customerNeolaneId);

  if (!bypassCache && cacheFrontEnabled && frontCachedResult) {
    return Promise.resolve(frontCachedResult);
  }

  var postRequest = !cacheable && !queryId;
  var requestOptions = {
    url: getGraphqlEndpoint({
      gqlQuery: gqlQuery,
      locale: locale,
      cmsRelease: cmsRelease,
      cmsContent: cmsContent,
      pagesContent: pagesContent,
      pagesRelease: pagesRelease,
      cacheable: cacheable,
      queryId: queryId,
      prebuiltArgs: prebuiltArgs
    }),
    method: postRequest ? 'post' : 'get',
    data: postRequest ? {
      query: encodeGQLQuery(cleanGQLQuery(gqlQuery))
    } : undefined,
    withCredentials: true,
    headers: getHeaders({
      requestId: requestId,
      origin: false ? undefined : _clubmed_utils__WEBPACK_IMPORTED_MODULE_8__["windowWrapper"].getLocation(),
      requestName: requestName,
      isDirectCxo: isDirectCxo,
      isIndirectCxo: isIndirectCxo,
      isCmta: isCmta,
      cacheable: cacheable,
      bypassCache: bypassCache,
      authenticationToken: authenticationToken,
      customerNeolaneId: customerNeolaneId,
      strictErrors: strictErrors
    })
  };
  return getAxiosInstance({
    gqlQuery: gqlQuery
  }).request(requestOptions).then(function (result) {
    if (cacheFrontEnabled && cacheKey) {
      Object(_cacheFront__WEBPACK_IMPORTED_MODULE_12__[/* setQueryResult */ "c"])({
        cacheKey: cacheKey,
        cacheExpirationDate: cacheExpirationDate,
        result: result,
        customerNeolaneId: customerNeolaneId
      });
    }

    return result;
  });
}

function runNoCacheQuery(gqlQuery, appContext, options) {
  return runQuery(gqlQuery, appContext, options, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  runQuery: runQuery,
  runNoCacheQuery: runNoCacheQuery
});

/***/ }),

/***/ "PSHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_CODE_200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_CODE_400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_CODE_401; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_CODE_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_CODE_409; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_CODE_500; });
var STATUS_CODE_200 = 200;
var STATUS_CODE_400 = 400;
var STATUS_CODE_401 = 401;
var STATUS_CODE_404 = 404;
var STATUS_CODE_409 = 409;
var STATUS_CODE_500 = 500;

/***/ }),

/***/ "Q2eF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "RDh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routesConf; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dNxv");

var routesConf = {
  account: {
    baseUrl: '/account'
  },
  activateAccount: {
    baseUrl: '/activateAccount'
  },
  agencyPickYourRoom: {
    baseUrl: '/agency/pick-your-room'
  },
  booking: {
    baseUrl: '/booking',
    args: ['page']
  },
  bookings: {
    baseUrl: '/account/bookings/:bookingId/stay/:stayId'
  },
  banking: {
    baseUrl: '/booking/banking'
  },
  confirmation: {
    baseUrl: '/confirmation'
  },
  comparator: {
    baseUrl: _constants__WEBPACK_IMPORTED_MODULE_0__[/* COMPARATOR_PATHNAME */ "e"]
  },
  contactInfo: {
    baseUrl: '/bi',
    args: ['proposalId']
  },
  dashboard: {
    baseUrl: '/account/dashboard'
  },
  editorialArticle: {
    baseUrl: '/articles/:slug'
  },
  editorialTheme: {
    baseUrl: '/themes/:slug'
  },
  error: {
    baseUrl: '/error'
  },
  fragments: {
    baseUrl: '/fragments/:fragment'
  },
  futureTrips: {
    baseUrl: '/account/future-trips'
  },
  greatMembers: {
    baseUrl: '/great-members'
  },
  home: {
    baseUrl: '/'
  },
  iframeCallback: {
    baseUrl: _constants__WEBPACK_IMPORTED_MODULE_0__[/* IFRAME_CALLBACK_URL */ "j"]
  },
  newsletterConfirmation: {
    baseUrl: '/newsletter/c',
    args: [{
      name: 'type',
      restrict: {
        subscription: 's',
        management: 'm'
      }
    }]
  },
  newsletterSubscription: {
    baseUrl: '/newsletter/s'
  },
  newsletterUnsubscription: {
    baseUrl: '/newsletter/u',
    args: ['subscriptionId']
  },
  offer: {
    baseUrl: '/o',
    args: ['offerName']
  },
  pastTrips: {
    baseUrl: '/account/past-trips'
  },
  pax: {
    baseUrl: '/pax'
  },
  paxConfirmation: {
    baseUrl: '/paxConfirmation'
  },
  payment: {
    baseUrl: '/pi',
    args: ['proposalId']
  },
  paymentConfirmation: {
    baseUrl: '/account/bookings/:bookingId/payment-confirmation'
  },
  paymentNotification: {
    baseUrl: '/payment-notification',
    args: ['paymentId', 'locale']
  },
  paymentRedirect: {
    baseUrl: '/payment-redirect'
  },
  pickYourRoom: {
    baseUrl: '/account/prepare-my-stay/pick-your-room',
    args: ['bookingId']
  },
  prebookingformSuccessSeller: {
    baseUrl: '/prebookingform/success-seller'
  },
  prepareMyStay: {
    baseUrl: '/account/prepare-my-stay/:bookingId/stay/:stayId'
  },
  prePayment: {
    baseUrl: '/pre-payment'
  },
  profile: {
    baseUrl: '/account/profile'
  },
  proposalPdf: {
    baseUrl: '/proposal-pdf/:proposalId'
  },
  resortPickYourRoom: {
    baseUrl: '/resort/pick-your-room'
  },
  search: {
    baseUrl: '/s'
  },
  searches: {
    baseUrl: '/account/searches'
  },
  siteplan: {
    baseUrl: _constants__WEBPACK_IMPORTED_MODULE_0__[/* SITEPLAN_PAGE_URL */ "F"]
  },
  signout: {
    baseUrl: '/signout'
  },
  stepup: {
    baseUrl: '/stepup'
  },
  sponsorship: {
    baseUrl: '/account/sponsorship'
  },
  optionConfirmation: {
    baseUrl: '/option/c',
    args: ['status']
  },
  optionConfirmationError: {
    baseUrl: '/option-error/c',
    args: ['status', 'error_code']
  },
  quickSearch: {
    baseUrl: _constants__WEBPACK_IMPORTED_MODULE_0__[/* QUICK_SEARCH_URL */ "C"]
  }
};

/***/ }),

/***/ "Soal":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("pQXz");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "T0aG":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "U2CP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return urlPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildUrl; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _routesConf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RDh2");





function getArgName(arg) {
  return typeof arg === 'string' ? arg : arg.name;
}

function urlPattern(routeName) {
  var route = _routesConf__WEBPACK_IMPORTED_MODULE_3__[/* routesConf */ "a"][routeName];
  var baseUrl = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(route, 'baseUrl');

  if (route.args) {
    var params = route.args.reduce(function (acc, arg) {
      return "".concat(acc, "/:").concat(getArgName(arg));
    }, '');
    return baseUrl + params;
  }

  return baseUrl;
}

function buildUrl(routeName, pathParams, queryParams) {
  var route = _routesConf__WEBPACK_IMPORTED_MODULE_3__[/* routesConf */ "a"][routeName];
  var pathParamsSegment = [];
  var url = route.baseUrl;
  pathParams = pathParams || {};

  if (route.args) {
    pathParamsSegment = route.args.map(function (arg) {
      if (typeof arg === 'string') {
        var param = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(pathParams, arg, null);

        if (param === null) {
          throw new Error("This route requires a ".concat(arg, " parameter"));
        }

        return param;
      }

      var paramName = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(arg, 'name', undefined);
      var restrictions = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(arg, 'restrict', undefined);

      if (!paramName) {
        throw new Error("The restricted argument for ".concat(route.baseUrl, " should have a name"));
      }

      if (!restrictions) {
        throw new Error("The restricted argument for ".concat(route.baseUrl, " should have a restrictions object"));
      }

      var paramValue = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(pathParams, paramName, null);

      if (paramValue === null) {
        throw new Error("This route requires a restricted ".concat(paramName, " parameter"));
      }

      var isValidParam = Object.keys(restrictions).some(function (restrictionName) {
        return paramValue === restrictions[restrictionName];
      });

      if (!isValidParam) {
        throw new Error("The ".concat(paramName, " does not match the restrictions"));
      }

      return paramValue;
    });
  }

  url = pathParamsSegment.length > 0 ? "".concat(url, "/").concat(pathParamsSegment.join('/')) : url;
  url = queryParams ? "".concat(url, "?").concat(urijs__WEBPACK_IMPORTED_MODULE_2___default.a.buildQuery(queryParams)) : url;

  if (pathParams) {
    Object.entries(pathParams).forEach(function (_ref) {
      var _ref2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (url.includes(':' + key) && (typeof value === 'string' || typeof value === 'number')) {
        url = url.replace(':' + key, String(value));
      }
    });
  }

  return url;
}



/***/ }),

/***/ "Ub5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return B2CAppContext; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ReactAppContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])({});
var B2CAppContext = function B2CAppContext(_ref) {
  var children = _ref.children,
      appContext = _ref.appContext;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(appContext),
      reactAppContext = _useState[0],
      setReactAppContext = _useState[1];

  var setCustomerStatus = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (customerStatus) {
    setReactAppContext(_objectSpread(_objectSpread({}, reactAppContext), {}, {
      customerStatus: customerStatus
    }));
  }, []);
  var value = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
    return _objectSpread(_objectSpread({}, reactAppContext), {}, {
      setCustomerStatus: setCustomerStatus
    });
  }, [reactAppContext]);
  return __jsx(ReactAppContext.Provider, {
    value: value
  }, children);
};
/* harmony default export */ __webpack_exports__["b"] = (ReactAppContext);

/***/ }),

/***/ "Umn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayWithHoles; });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ "VrFO":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "WBY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "XLvf":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("72zh");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("qW1w");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "Y9Ll":
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "YsDt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("dyNj");
var utils = __webpack_require__("P0jV");
var InterceptorManager = __webpack_require__("O3AJ");
var dispatchRequest = __webpack_require__("BtTt");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "ZCNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _Responsive_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("GRjW");
/* harmony import */ var _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I6kL");




function isBrowserGreaterThan(currentBreakpoint) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XXS;
  var currentBpIndex = _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* ORDERED_BREAKPOINTS */ "d"].indexOf(currentBreakpoint);
  var stepIndex = _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* ORDERED_BREAKPOINTS */ "d"].indexOf(breakpoint);
  return currentBpIndex > stepIndex;
}

function isDesktop(currentBreakpoint) {
  return currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].L || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XL;
}

function isTablet(currentBreakpoint) {
  return isDesktop(currentBreakpoint) || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].M || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].S;
}

function isMobile(currentBreakpoint) {
  return isTablet(currentBreakpoint) || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XS;
}

function getCurrentResponsive(_ref) {
  var _isBrowserGreaterThan;

  var currentBreakpoint = _ref.currentBreakpoint,
      isAppMounted = _ref.isAppMounted;
  return {
    isAppMounted: isAppMounted,
    currentBreakpoint: currentBreakpoint,
    domAspect: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_1__[/* getDOMAspect */ "b"])(isAppMounted),
    isLandscape: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_1__[/* isLandscape */ "c"])(isAppMounted),
    isMobile: isMobile(currentBreakpoint),
    isRTL: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_1__[/* isRTL */ "d"])(isAppMounted),
    isTablet: isTablet(currentBreakpoint),
    isDesktop: isDesktop(currentBreakpoint),
    isBrowserGreaterThan: (_isBrowserGreaterThan = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XXS, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XXS)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XS, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].XS)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].S, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].S)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].M, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].M)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].L, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"].L)), _isBrowserGreaterThan)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getCurrentResponsive);

/***/ }),

/***/ "ZOp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_ANCHOR */
/* unused harmony export MAIN */
/* unused harmony export ADULTS */
/* unused harmony export KIDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return YEAR_OF_MAJORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CNIL_LEGAL_MESSAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GENERAL_PERSONAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNIQUE_IDENTIFICATION_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return THIRD_PARTY_PROVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OVERSEAS_PROVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OVERSEAS_PROVISION_INSURANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WRONG_SALESMAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SALESMAN_ID_WARNING_MESSAGE; });
var SCROLL_ANCHOR = 'scrollAnchor';
var MAIN = 'main';
var ADULTS = 'adults';
var KIDS = 'kids';
var YEAR_OF_MAJORITY = 18;
var MAX_AGE = 100; // CGUs IDs

var CNIL_LEGAL_MESSAGE_ID = 'CNIL';
var GENERAL_PERSONAL_INFORMATION = 'GENERAL_PERSONAL_INFORMATION';
var UNIQUE_IDENTIFICATION_INFORMATION = 'UNIQUE_IDENTIFICATION_INFORMATION';
var THIRD_PARTY_PROVISION = 'THIRD_PARTY_PROVISION';
var OVERSEAS_PROVISION = 'OVERSEAS_PROVISION';
var OVERSEAS_PROVISION_INSURANCE = 'OVERSEAS_PROVISION_INSURANCE';
var WRONG_SALESMAN_ID = 'WRONG_SALESMAN_ID';
var SALESMAN_ID_WARNING_MESSAGE = 'SALESMAN_ID_WARNING_MESSAGE';

/***/ }),

/***/ "ZxLh":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ "d5r3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _clubmed_config_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("joSE");
/* harmony import */ var _clubmed_config_util__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_config_util__WEBPACK_IMPORTED_MODULE_0__);

var appConfig = _clubmed_config_util__WEBPACK_IMPORTED_MODULE_0___default()(window.appConfig || {});
appConfig.set('graphql.host', appConfig.get('proxy.activate') ? appConfig.get('proxy.contextPath') : appConfig.get('graphql.clientHost'));
/* harmony default export */ __webpack_exports__["default"] = (appConfig);

/***/ }),

/***/ "dNxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ACCOMMODATION_PATHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_CONFIRMATION_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_ENGINE_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPARATOR_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPARATOR_PATHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return IFRAME_CALLBACK_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IFRAME_CALLBACK_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OPTION_CONFIRMATION_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PROPOSAL_PDF_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return QUICK_SEARCH_SELLER_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return QUICK_SEARCH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PLE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PLE_BOOKINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PLE_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PLE_FUTURE_TRIPS_PAGE_ID; });
/* unused harmony export PLE_GREAT_MEMBERS_PAGE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PLE_PAST_TRIPS_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PLE_PAYMENT_CONFIRMATION_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PLE_PICK_YOUR_ROOM_AGENCY_PAGE_ID; });
/* unused harmony export PLE_PICK_YOUR_ROOM_PAGE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PLE_PICK_YOUR_ROOM_RESORT_PAGE_ID; });
/* unused harmony export PLE_PREPARE_MY_STAY_PAGE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PLE_PRE_PAYMENT_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PLE_PROFILE_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PLE_SEARCHES_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PLE_SPONSORSHIP_PAGE_ID; });
/* unused harmony export SIGNOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDITORIAL_ARTICLE_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDITORIAL_THEME_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME; });
/* unused harmony export FRAGMENTS_FOOTER_PAGE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NEWSLETTER_CONFIRMATION_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEWSLETTER_SUBSCRIPTION_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEWSLETTER_UNSUBSCRIPTION_PAGE_ID; });
/* unused harmony export PAYMENT_REDIRECT_PAGE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SEARCH_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SITEPLAN_PAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SITEPLAN_PAGE_URL; });
// BE
var BOOKING_ACCOMMODATION_PATHNAME = '/booking/accommodation';
var BOOKING_CONFIRMATION_PAGE_ID = 'booking-confirmation';
var BOOKING_ENGINE_PAGE_ID = 'bookingEngine';
var COMPARATOR_PAGE_ID = 'comparator';
var COMPARATOR_PATHNAME = '/comparator';
var IFRAME_CALLBACK_PAGE_ID = 'iframe-callback';
var IFRAME_CALLBACK_URL = '/iframe-callback';
var OPTION_CONFIRMATION_PAGE_ID = 'option-confirmation';
var PROPOSAL_PDF_PAGE_ID = 'proposal-pdf';
var QUICK_SEARCH_SELLER_PAGE_ID = 'quick-search';
var QUICK_SEARCH_URL = '/quick-search'; // PLE

var PLE_ACCOUNT = 'ple-account';
var PLE_BOOKINGS = 'ple-bookings';
var PLE_DASHBOARD = 'ple-dashboard';
var PLE_FUTURE_TRIPS_PAGE_ID = 'ple-future-trips';
var PLE_GREAT_MEMBERS_PAGE_ID = 'ple-great-members';
var PLE_PAST_TRIPS_PAGE_ID = 'ple-past-trips';
var PLE_PAYMENT_CONFIRMATION_PAGE_ID = 'ple-payment-confirmation';
var PLE_PICK_YOUR_ROOM_AGENCY_PAGE_ID = 'ple-pick-your-room-agency';
var PLE_PICK_YOUR_ROOM_PAGE_ID = 'ple-pick-your-room';
var PLE_PICK_YOUR_ROOM_RESORT_PAGE_ID = 'ple-pick-your-room-resort';
var PLE_PREPARE_MY_STAY_PAGE_ID = 'ple-prepare-my-stay';
var PLE_PRE_PAYMENT_PAGE_ID = 'ple-pre-payment';
var PLE_PROFILE_PAGE_ID = 'ple-profile';
var PLE_SEARCHES_PAGE_ID = 'ple-searches';
var PLE_SPONSORSHIP_PAGE_ID = 'ple-sponsorship';
var SIGNOUT = 'signout'; // SHOPPING

var EDITORIAL_ARTICLE_PAGE_ID = 'article';
var EDITORIAL_THEME_PAGE_ID = 'theme';
var HOME = 'home';
var FRAGMENTS_FOOTER_PAGE_ID = 'fragments-footer';
var NEWSLETTER_CONFIRMATION_PAGE_ID = 'newsletter-confirmation';
var NEWSLETTER_SUBSCRIPTION_PAGE_ID = 'newsletter-subscription';
var NEWSLETTER_UNSUBSCRIPTION_PAGE_ID = 'newsletter-unsubscription';
var PAYMENT_REDIRECT_PAGE_ID = 'payment-redirect';
var SEARCH_PAGE_ID = 'search';
var SITEPLAN_PAGE_ID = 'siteplan';
var SITEPLAN_PAGE_URL = "/".concat(SITEPLAN_PAGE_ID);

/***/ }),

/***/ "dyNj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("P0jV");
var normalizeHeaderName = __webpack_require__("rFSu");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("Ay6X");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("Ay6X");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "eGgp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "fGyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _toConsumableArray; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__("lEbO");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__("5x5+");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("HO86");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || Object(iterableToArray["a" /* default */])(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
}

/***/ }),

/***/ "ggb3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8dj6");

/***/ }),

/***/ "heQk":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"), __webpack_require__("Cf/K"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),

/***/ "i3c9":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ "joSE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {
/* eslint-disable no-console */

__webpack_require__("2G9S");

__webpack_require__("M+/F");

__webpack_require__("IAdD");

__webpack_require__("+KXO");

__webpack_require__("KqXw");

__webpack_require__("Ysgh");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _require = __webpack_require__("nsO7"),
    merge = _require.merge,
    clone = _require.clone,
    get = _require.get,
    has = _require.has;

var flat = __webpack_require__("oEtN");

var unflatten = flat.unflatten;

function toJSON(key, value) {
  /*
  * JSON.parse will handle data like "true", "True", "false", "False", "1", "0"
  * (that's why we use .toLowerCase() before)
  * and convert them to Boolean or Number
  * Other strings will throw an exception and will be left as it is.
  */
  try {
    return _defineProperty({}, key, JSON.parse(value.toLowerCase()));
  } catch (e) {
    return _defineProperty({}, key, value);
  }
}

function parse(configData) {
  var flattedData = flat(configData);
  var parsedConfig = Object.keys(flattedData).reduce(function (acc, key) {
    return Object.assign(acc, toJSON(key, flattedData[key]));
  }, {});
  return unflatten(parsedConfig);
}

function mergeWithTypeCoercion(config, data) {
  return parse(merge({}, config, data));
}

function Config(data) {
  if (!(this instanceof Config)) {
    return new Config(data);
  }

  this.configStore = mergeWithTypeCoercion(this.configStore, data);
}

Config.prototype.add = function addData(data) {
  this.configStore = mergeWithTypeCoercion(this.configStore, data);
  return this;
};

Config.prototype.env = function addEnvData() {
  var processEnv = unflatten(process && process.env);
  this.configStore = mergeWithTypeCoercion(this.configStore, processEnv);
  return this;
};

Config.prototype.argv = function addCommandLineArgs(argv) {
  argv = argv || process && process.argv;

  if (argv) {
    var appArgs = argv.slice(2).reduce(function (args, arg) {
      var argData = arg.split("=");

      if (argData.length === 2) {
        args[argData[0]] = argData[1];
      }

      return args;
    }, {});
    this.configStore = mergeWithTypeCoercion(this.configStore, unflatten(appArgs));
  }

  return this;
};

Config.prototype.locale = function locale(overrideLocal) {
  var newVar = this.get();
  delete newVar.override;
  return new Config(merge({}, newVar, this.get(["override", overrideLocal])));
};

Config.prototype.file = function addFile(configFilename) {
  if (false) { var fs; }

  return this;
};

Config.prototype.get = function getConfigValue(configKey, locale) {
  var overrideKey = "override.".concat(locale, ".").concat(configKey);

  if (locale && has(this.configStore, overrideKey)) {
    return get(this.configStore, overrideKey);
  }

  return configKey ? get(this.configStore, configKey) : clone(this.configStore);
};

Config.prototype.set = function setConfigValue(configKey, configValue) {
  var o = {};
  o[configKey] = configValue;
  this.configStore = mergeWithTypeCoercion(this.configStore, unflatten(o));
  return this;
};

Config.prototype.hydrate = function hydrate(windowRef) {
  if (global.window && global.window.clubmed) {
    this.configStore = mergeWithTypeCoercion(this.configStore, global.window.clubmed[windowRef]);
  }

  return this;
};

Config.prototype.dehydrate = function dehydrate() {
  return JSON.stringify(this.get());
};

module.exports = Config;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i"), __webpack_require__("lpmq")))

/***/ }),

/***/ "kQdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _nonIterableRest; });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "lEbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayLikeToArray; });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "ldK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_MONTH_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UTC_DATE_TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return momentFromApiDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return momentToApiDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return momentFromApiTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return momentToApiTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiDateToTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return timestampToApiDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatApiDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatApiTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPeriodsMoment; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var API_MONTH_ID = 'YYYYMM';
var API_DATE_FORMAT = 'YYYYMMDD';
var API_TIME_FORMAT = 'HH:mm:ss.SSS';
var UTC_DATE_TIME_FORMAT = 'YYYYMMDDTHH:mm:ss.SSSZ';
function momentFromApiDate(apiDate) {
  return moment__WEBPACK_IMPORTED_MODULE_0___default()(apiDate, API_DATE_FORMAT);
}
function momentToApiDate(date) {
  return date.format(API_DATE_FORMAT);
}
function momentFromApiTime(apiTime) {
  return moment__WEBPACK_IMPORTED_MODULE_0___default()(apiTime, API_TIME_FORMAT);
}
function momentToApiTime(date) {
  return date.format(API_TIME_FORMAT);
}
function apiDateToTimestamp(apiDate) {
  return apiDate ? moment__WEBPACK_IMPORTED_MODULE_0___default()(apiDate, API_DATE_FORMAT).valueOf() : null;
}
function timestampToApiDate(timestamp) {
  return timestamp ? moment__WEBPACK_IMPORTED_MODULE_0___default()(timestamp).format(API_DATE_FORMAT) : null;
}
function formatApiDate(apiDate, format) {
  return moment__WEBPACK_IMPORTED_MODULE_0___default()(apiDate, API_DATE_FORMAT).format(format);
}
function formatApiTime(apiTime, format) {
  return moment__WEBPACK_IMPORTED_MODULE_0___default()(apiTime, API_TIME_FORMAT).format(format);
}
function getPeriodsMoment(date) {
  return date.hours() > 12 ? 'PM' : 'AM';
}

/***/ }),

/***/ "lfu7":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "m0zD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable no-console, import/no-commonjs */


module.exports = __webpack_require__("zytj");

/***/ }),

/***/ "oEtN":
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__("lfu7")

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),

/***/ "pQXz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("M44J");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "qW1w":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "rFSu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "rOcY":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable import/no-commonjs */
if (false) {} else {
  module.exports = __webpack_require__("d5r3");
}

/***/ }),

/***/ "tZkf":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("Ni7E"));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ "taV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BE_ACCOMMODATIONS_LAYER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BE_CATEGORY_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BE_SAVE_VALIDATE_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BE_SAVE_CLICK_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BE_SIGNIN_CLICK_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BE_SIGNUP_CLICK_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BE_FACEBOOK_CONNECT_CLICK_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BE_SHARE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BE_SAVE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BE_SAVE_CRITERIA_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BOOKING_SELECTED_RESORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BOOKING_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BOOKING_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BE_GA_DEFAULT_PAYLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CXO_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CXO_STEP_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CRITERIA_SELECTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MULTI_SCHEDULE_RESORTS; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var BE_ACCOMMODATIONS_LAYER_NAME = 'AdditionalAccommodationsLayer';
var BE_CATEGORY_GA = 'bookingEngine';
var BE_SAVE_VALIDATE_GA = 'validate';
var BE_SAVE_CLICK_GA = 'click';
var BE_SIGNIN_CLICK_GA = 'login';
var BE_SIGNUP_CLICK_GA = 'createAccount';
var BE_FACEBOOK_CONNECT_CLICK_GA = 'facebookconnect';
var BE_SHARE_ACTION = 'share-action';
var BE_SAVE_ACTION = 'save-action';
var BE_SAVE_CRITERIA_QUERY = 'openSaveConfirmationModal';
var BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY = 'newAccount';
var BOOKING_SELECTED_RESORT_ID = 'selectedProposalId';
var BOOKING_QUERY_PARAMS = 'bookingQueryParams';
var BOOKING_ENTRY_ROUTE = 'entryRoute';
var BE_GA_DEFAULT_PAYLOAD = _objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_1__[/* GA_DEFAULT_PAYLOAD */ "i"]), {}, {
  categoryGA: BE_CATEGORY_GA
});
var CXO_STEP = {
  CONFIGURE: 'configure',
  AFFICHAGE: 'affichage',
  PAYMENT: 'payment'
};
var CXO_STEP_GA = {
  configure: 'CXO_modifyFile',
  affichage: 'CXO_saveOption',
  payment: 'CXO_confirm'
};
var PAGES = {
  ACTIVITIES: 'activities',
  BANKING: 'banking',
  ACCOMMODATION: 'accommodation',
  TRANSPORT: 'transport',
  SERVICES: 'services',
  PARTICIPANTS: 'participants',
  SUMMARY: 'summary'
};
var CRITERIA_SELECTORS = {
  ATTENDEES: 'criteria-attendees',
  DEPARTURE: 'criteria-departure',
  PRODUCT: 'criteria-product',
  TRANSPORT: 'criteria-transport'
};
var MULTI_SCHEDULE_RESORTS = ['TOMC_WINTER', 'SAOC_WINTER'];

/***/ }),

/***/ "uld8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function exist(value) {
  return value !== undefined && value !== null;
}

function isArray(value) {
  return value instanceof Array;
}

function isObject(value) {
  return exist(value) && typeof value === "object" && !isArray(value);
}

function isPrimitive(value) {
  return exist(value) && !isObject(value) && !isArray(value);
}

function isString(value) {
  return typeof value === "string";
}

module.exports = {
  isArray : isArray,
  isObject : isObject,
  isPrimitive : isPrimitive,
  isString : isString
};


/***/ }),

/***/ "vfGT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "wd/R":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    undefined
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "x5Ag":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__("XLvf");
var assign = __webpack_require__("NByd");
var Type = __webpack_require__("uld8");

function normalizeErrorArgs(args) {
  return Type.isString(args) ? {name : args} : args;
}

function normalizeCustomErrorArgs(args) {
  return Type.isString(args) ? {message : args} : args;
}

function ensureArgs(args) {
  if (Type.isString(args) || (Type.isObject(args) && Type.isString(args.name))) {
    return;
  }
  throw new Error("Invalid CustomError arguments");
}

function createCustomError(defaultErrorArgs, ParentError) {

  ensureArgs(defaultErrorArgs);

  var CustomError = function(customErrorArgs) {
    assign(this, normalizeCustomErrorArgs(customErrorArgs));

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  };

  util.inherits(CustomError, ParentError || Error);
  assign(CustomError.prototype, normalizeErrorArgs(defaultErrorArgs));
  CustomError.prototype.toJSON = function toJSON() {
    return assign({}, this);
  };

  return CustomError;
}

function isCustomError(err) {
  function getPrototypeOfConstructor(instance) {
    return instance && instance.constructor && instance.constructor.prototype;
  }

  return getPrototypeOfConstructor(getPrototypeOfConstructor(err)) instanceof Error;
}

module.exports = {
  create : createCustomError,
  isCustom : isCustomError,
};


/***/ }),

/***/ "yOYy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "ym5Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("P0jV");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "zygG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _slicedToArray; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__("Umn3");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("HO86");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__("kQdG");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return Object(arrayWithHoles["a" /* default */])(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || Object(nonIterableRest["a" /* default */])();
}

/***/ }),

/***/ "zytj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// eslint-disable-next-line import/no-mutable-exports
var logger = console;

if (false) { var config, bunyan; }

/* harmony default export */ __webpack_exports__["default"] = (logger);

/***/ })

}]);